import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1x79l67jvwntn as serializer,
  InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor,
  SEALED_getInstance3nsev85ow9059 as SEALED_getInstance,
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  KSerializerzf77vz1967fq as KSerializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  STRING_getInstance2ou4lro9xn2qn as STRING_getInstance,
  ENUM_getInstance22lfbrqor0c0a as ENUM_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  serializer2lw83vwvpnyms as serializer_0,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  Encoderqvmrpqtq8hnu as Encoder,
  ElementMarker33ojvsajwmzts as ElementMarker,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  SerializationException_init_$Init$nhp5tm45z5re as SerializationException_init_$Init$,
  CLASS_getInstance14ex35co4jkrb as CLASS_getInstance,
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames,
  ENUMlmq49cvwy4ow as ENUM,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  MissingFieldException24tqif29emcmi as MissingFieldException,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  OBJECT_getInstance26229tfe4t547 as OBJECT_getInstance,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  serializer3ikrxnm8b29d6 as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1q7c5q67ysppr as serializer_3,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
  CONTEXTUAL_getInstance1845118lbzky0 as CONTEXTUAL_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KtMap140uvy3s5zad8 as KtMap,
  toString1pkumu07cwy4m as toString_0,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  KtList3hktaavzmj137 as KtList,
  NumberFormatException_init_$Create$361k2w325ylq7 as NumberFormatException_init_$Create$,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ClosedRangehokgr73im9z3 as ClosedRange,
  isInterface3d6p8outrmvmk as isInterface,
  contains2c50nlxg7en7o as contains,
  convertToIntofdoxh9bstof as convertToInt,
  toDouble1kn912gjoizjp as toDouble,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toULongOrNullojoyxi0i9tgj as toULongOrNull,
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance1puqqwzccfvrg as Companion_getInstance,
  _ULong___get_data__impl__fggpzb2qlkrfp9zs48z as _ULong___get_data__impl__fggpzb,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  fromInt1lka3ktyu79a4 as fromInt,
  _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl213fqto411a11p0 as UInt__toString_impl_dbgl21,
  _ULong___init__impl__c78o9k1p6qzv0dh0bvg as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7kivnvhcxkib53 as ULong__toString_impl_f9au7k,
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg2vnfngefiworp as UByte__toString_impl_v72jg,
  _UShort___init__impl__jigrne2jag2u7194ozm as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee3e5ovvzk9wm4f as UShort__toString_impl_edaoee,
  captureStack1fzi4aczwc4hg as captureStack,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  LinkedHashMap_init_$Create$1f9mb1z5f3dxn as LinkedHashMap_init_$Create$,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  singleOrNullrknfaxokm1sl as singleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
  copyOf2ng0t8oizk6it as copyOf,
  copyOf3rutauicler23 as copyOf_0,
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
  Unitkvevlwgzwiuc as Unit,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  getKClass3t8tygqu4lcxf as getKClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains_0,
  plus17rl43at52ays as plus,
  convertToByte1epqhkuyxuz5a as convertToByte,
  equalsLong28bsrfhwvd686 as equalsLong,
  convertToShortvtefcftm709c as convertToShort,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
  charCodeAt1yspne1d8erbm as charCodeAt,
  toUInt21lx0mz8wkp7c as toUInt,
  _UInt___get_data__impl__f0vqqw13y1a2xkii3dn as _UInt___get_data__impl__f0vqqw,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr,
  toUShort7yqspfnhrot4 as toUShort,
  _UShort___get_data__impl__g0245hlms5v6vgvnl as _UShort___get_data__impl__g0245,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString3o7ifthqydp6e as toString_1,
  Companion_getInstanceuedpedmz4g65 as Companion_getInstance_0,
  Companion_getInstance1trnkq9cty7vr as Companion_getInstance_1,
  Companion_getInstance2du03jiluw9jj as Companion_getInstance_2,
  setOf45ia9pnfhe90 as setOf,
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  equals2v6cggk171b6e as equals_0,
  toByte4i43936u611k as toByte,
  startsWith26w8qjqapeeq6 as startsWith,
  toShort36kaw0zjdq3ex as toShort,
  single29ec4rh52687r as single,
  Char19o2r8palgjof as Char,
  emptySetcxexqki71qfa as emptySet,
  plus1ogy4liedzq5j as plus_0,
  toInt2q8uldh7sc951 as toInt,
  toList3jhuyej2anx2q as toList,
  enumEntries20mr21zbe3az4 as enumEntries,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  toNumberlmbpvqo27r53 as toNumber,
  last1vo29oleiqj36 as last,
  removeLast3759euu1xvfa3 as removeLast,
  lastIndexOf2d52xhix5ymjr as lastIndexOf,
  Long2qws0ah9gnpki as Long,
  Char__minus_impl_a2frrh3548ixwefqxih as Char__minus_impl_a2frrh,
  multiply18i3gv3wlmcjg as multiply,
  add85si75olwt6n as add,
  subtract16cg4lfi29fq9 as subtract,
  compare2uud5j30pw5xc as compare,
  numberToLong345n6tb1n1i71 as numberToLong,
  negate12tprdg5pyd5t as negate,
  charArray2ujmm1qusno00 as charArray,
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
  substringiqarkczpya5m as substring,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$_0,
  HashMap_init_$Create$36kepqnl5avn5 as HashMap_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(Json, 'Json');
initMetadataForObject(Default, 'Default', VOID, Json);
initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
initMetadataForClass(JsonNames, 'JsonNames');
initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode', VOID, Enum);
initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForCompanion(Companion);
initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
initMetadataForCompanion(Companion_1);
initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
initMetadataForCompanion(Companion_2);
initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder]);
initMetadataForClass(Composer, 'Composer');
initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
initMetadataForObject(Tombstone, 'Tombstone');
initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($readObjectCOROUTINE$, CoroutineImpl);
initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [1]);
initMetadataForClass(Key, 'Key', Key);
initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
initMetadataForObject(CharMappings, 'CharMappings');
initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments', VOID, StringJsonLexer);
initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
//endregion
function Default() {
  Default_instance = this;
  Json.call(this, new JsonConfiguration(), EmptySerializersModule());
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance == null)
    new Default();
  return Default_instance;
}
function Json(configuration, serializersModule) {
  Default_getInstance();
  this.yx_1 = configuration;
  this.zx_1 = serializersModule;
  this.ay_1 = new DescriptorSchemaCache();
}
protoOf(Json).ui = function () {
  return this.zx_1;
};
protoOf(Json).by = function (serializer, value) {
  var result = new JsonToStringWriter();
  try {
    encodeByWriter(this, result, serializer, value);
    return result.toString();
  }finally {
    result.ey();
  }
};
protoOf(Json).cy = function (deserializer, string) {
  var lexer = StringJsonLexer_0(this, string);
  var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.jf(), null);
  var result = input.fi(deserializer);
  lexer.ry();
  return result;
};
function JsonClassDiscriminator() {
}
function JsonNames() {
}
function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
  encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
  ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
  isLenient = isLenient === VOID ? false : isLenient;
  allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
  prettyPrint = prettyPrint === VOID ? false : prettyPrint;
  explicitNulls = explicitNulls === VOID ? true : explicitNulls;
  prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
  coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
  useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
  classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
  allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
  useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
  namingStrategy = namingStrategy === VOID ? null : namingStrategy;
  decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
  allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
  allowComments = allowComments === VOID ? false : allowComments;
  classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
  this.sy_1 = encodeDefaults;
  this.ty_1 = ignoreUnknownKeys;
  this.uy_1 = isLenient;
  this.vy_1 = allowStructuredMapKeys;
  this.wy_1 = prettyPrint;
  this.xy_1 = explicitNulls;
  this.yy_1 = prettyPrintIndent;
  this.zy_1 = coerceInputValues;
  this.az_1 = useArrayPolymorphism;
  this.bz_1 = classDiscriminator;
  this.cz_1 = allowSpecialFloatingPointValues;
  this.dz_1 = useAlternativeNames;
  this.ez_1 = namingStrategy;
  this.fz_1 = decodeEnumsCaseInsensitive;
  this.gz_1 = allowTrailingComma;
  this.hz_1 = allowComments;
  this.iz_1 = classDiscriminatorMode;
}
protoOf(JsonConfiguration).toString = function () {
  return 'JsonConfiguration(encodeDefaults=' + this.sy_1 + ', ignoreUnknownKeys=' + this.ty_1 + ', isLenient=' + this.uy_1 + ', ' + ('allowStructuredMapKeys=' + this.vy_1 + ', prettyPrint=' + this.wy_1 + ', explicitNulls=' + this.xy_1 + ', ') + ("prettyPrintIndent='" + this.yy_1 + "', coerceInputValues=" + this.zy_1 + ', useArrayPolymorphism=' + this.az_1 + ', ') + ("classDiscriminator='" + this.bz_1 + "', allowSpecialFloatingPointValues=" + this.cz_1 + ', ') + ('useAlternativeNames=' + this.dz_1 + ', namingStrategy=' + toString(this.ez_1) + ', decodeEnumsCaseInsensitive=' + this.fz_1 + ', ') + ('allowTrailingComma=' + this.gz_1 + ', allowComments=' + this.hz_1 + ', classDiscriminatorMode=' + this.iz_1.toString() + ')');
};
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
}
function ClassDiscriminatorMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
function JsonDecoder() {
}
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
function Companion() {
}
var Companion_instance;
function Companion_getInstance_3() {
  return Companion_instance;
}
function JsonElement() {
}
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.m1();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.n1();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  printQuoted(this_0, k);
  this_0.m6(_Char___init__impl__6a9atx(58));
  this_0.k6(v);
  return this_0.toString();
}
function JsonObject(content) {
  JsonElement.call(this);
  this.lz_1 = content;
}
protoOf(JsonObject).equals = function (other) {
  return equals(this.lz_1, other);
};
protoOf(JsonObject).hashCode = function () {
  return hashCode(this.lz_1);
};
protoOf(JsonObject).toString = function () {
  var tmp = this.lz_1.t1();
  return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
};
protoOf(JsonObject).mz = function (key) {
  return this.lz_1.o1(key);
};
protoOf(JsonObject).o1 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return false;
  return this.mz((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(JsonObject).nz = function (key) {
  return this.lz_1.q1(key);
};
protoOf(JsonObject).q1 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return null;
  return this.nz((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(JsonObject).l = function () {
  return this.lz_1.l();
};
protoOf(JsonObject).t1 = function () {
  return this.lz_1.t1();
};
protoOf(JsonObject).r1 = function () {
  return this.lz_1.r1();
};
protoOf(JsonObject).k = function () {
  return this.lz_1.k();
};
protoOf(JsonObject).s1 = function () {
  return this.lz_1.s1();
};
function JsonNull() {
  JsonNull_instance = this;
  JsonPrimitive.call(this);
  this.oz_1 = 'null';
}
protoOf(JsonNull).pz = function () {
  return this.oz_1;
};
protoOf(JsonNull).qz = function () {
  return JsonNullSerializer_getInstance();
};
protoOf(JsonNull).wp = function (typeParamsSerializers) {
  return this.qz();
};
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance == null)
    new JsonNull();
  return JsonNull_instance;
}
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
function JsonPrimitive() {
  JsonElement.call(this);
}
protoOf(JsonPrimitive).toString = function () {
  return this.pz();
};
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, true);
}
function JsonLiteral(body, isString, coerceToInlineType) {
  coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
  JsonPrimitive.call(this);
  this.rz_1 = isString;
  this.sz_1 = coerceToInlineType;
  this.tz_1 = toString_0(body);
  if (!(this.sz_1 == null)) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.sz_1.pg()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
  }
}
protoOf(JsonLiteral).pz = function () {
  return this.tz_1;
};
protoOf(JsonLiteral).toString = function () {
  var tmp;
  if (this.rz_1) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    printQuoted(this_0, this.tz_1);
    tmp = this_0.toString();
  } else {
    tmp = this.tz_1;
  }
  return tmp;
};
protoOf(JsonLiteral).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof JsonLiteral))
    THROW_CCE();
  if (!(this.rz_1 === other.rz_1))
    return false;
  if (!(this.tz_1 === other.tz_1))
    return false;
  return true;
};
protoOf(JsonLiteral).hashCode = function () {
  var result = getBooleanHashCode(this.rz_1);
  result = imul(31, result) + getStringHashCode(this.tz_1) | 0;
  return result;
};
function Companion_2() {
}
var Companion_instance_2;
function Companion_getInstance_6() {
  return Companion_instance_2;
}
function JsonArray(content) {
  JsonElement.call(this);
  this.uz_1 = content;
}
protoOf(JsonArray).equals = function (other) {
  return equals(this.uz_1, other);
};
protoOf(JsonArray).hashCode = function () {
  return hashCode(this.uz_1);
};
protoOf(JsonArray).toString = function () {
  return joinToString(this.uz_1, ',', '[', ']');
};
protoOf(JsonArray).m = function (index) {
  return this.uz_1.m(index);
};
protoOf(JsonArray).l = function () {
  return this.uz_1.l();
};
protoOf(JsonArray).h = function () {
  return this.uz_1.h();
};
protoOf(JsonArray).k = function () {
  return this.uz_1.k();
};
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull_0(_this__u8e3s4.pz());
}
function get_int(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.mapExceptions' call
  var tmp;
  try {
    tmp = (new StringJsonLexer(_this__u8e3s4.pz())).vz();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      throw NumberFormatException_init_$Create$(e.message);
    } else {
      throw $p;
    }
  }
  var result = tmp;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(-2147483648, 2147483647);
  if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result))
    throw NumberFormatException_init_$Create$(_this__u8e3s4.pz() + ' is not an Int');
  return convertToInt(result);
}
function get_long(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.mapExceptions' call
  var tmp;
  try {
    tmp = (new StringJsonLexer(_this__u8e3s4.pz())).vz();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      throw NumberFormatException_init_$Create$(e.message);
    } else {
      throw $p;
    }
  }
  return tmp;
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.pz();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.pz());
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.pz();
  }
  return tmp;
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException_init_$Create$('Element ' + toString_0(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.uf('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.uf('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.uf('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.uf('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.uf('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().wz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().xz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().yz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().zz_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().a10_1;
}
function JsonElementSerializer() {
  JsonElementSerializer_instance = this;
  var tmp = this;
  var tmp_0 = SEALED_getInstance();
  tmp.b10_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
}
protoOf(JsonElementSerializer).jf = function () {
  return this.b10_1;
};
protoOf(JsonElementSerializer).c10 = function (encoder, value) {
  verify(encoder);
  if (value instanceof JsonPrimitive) {
    encoder.wj(JsonPrimitiveSerializer_getInstance(), value);
  } else {
    if (value instanceof JsonObject) {
      encoder.wj(JsonObjectSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonArray) {
        encoder.wj(JsonArraySerializer_getInstance(), value);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
};
protoOf(JsonElementSerializer).kf = function (encoder, value) {
  return this.c10(encoder, value instanceof JsonElement ? value : THROW_CCE());
};
protoOf(JsonElementSerializer).lf = function (decoder) {
  var input = asJsonDecoder(decoder);
  return input.kz();
};
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance == null)
    new JsonElementSerializer();
  return JsonElementSerializer_instance;
}
function JsonObjectDescriptor() {
  JsonObjectDescriptor_instance = this;
  this.d10_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).jf();
  this.e10_1 = 'kotlinx.serialization.json.JsonObject';
}
protoOf(JsonObjectDescriptor).ng = function () {
  return this.e10_1;
};
protoOf(JsonObjectDescriptor).sg = function (index) {
  return this.d10_1.sg(index);
};
protoOf(JsonObjectDescriptor).tg = function (name) {
  return this.d10_1.tg(name);
};
protoOf(JsonObjectDescriptor).ug = function (index) {
  return this.d10_1.ug(index);
};
protoOf(JsonObjectDescriptor).vg = function (index) {
  return this.d10_1.vg(index);
};
protoOf(JsonObjectDescriptor).wg = function (index) {
  return this.d10_1.wg(index);
};
protoOf(JsonObjectDescriptor).og = function () {
  return this.d10_1.og();
};
protoOf(JsonObjectDescriptor).jg = function () {
  return this.d10_1.jg();
};
protoOf(JsonObjectDescriptor).pg = function () {
  return this.d10_1.pg();
};
protoOf(JsonObjectDescriptor).qg = function () {
  return this.d10_1.qg();
};
protoOf(JsonObjectDescriptor).rg = function () {
  return this.d10_1.rg();
};
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance == null)
    new JsonObjectDescriptor();
  return JsonObjectDescriptor_instance;
}
function JsonObjectSerializer() {
  JsonObjectSerializer_instance = this;
  this.zz_1 = JsonObjectDescriptor_getInstance();
}
protoOf(JsonObjectSerializer).jf = function () {
  return this.zz_1;
};
protoOf(JsonObjectSerializer).f10 = function (encoder, value) {
  verify(encoder);
  MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).kf(encoder, value);
};
protoOf(JsonObjectSerializer).kf = function (encoder, value) {
  return this.f10(encoder, value instanceof JsonObject ? value : THROW_CCE());
};
protoOf(JsonObjectSerializer).lf = function (decoder) {
  verify_0(decoder);
  return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).lf(decoder));
};
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance == null)
    new JsonObjectSerializer();
  return JsonObjectSerializer_instance;
}
function JsonArrayDescriptor() {
  JsonArrayDescriptor_instance = this;
  this.g10_1 = ListSerializer(JsonElementSerializer_getInstance()).jf();
  this.h10_1 = 'kotlinx.serialization.json.JsonArray';
}
protoOf(JsonArrayDescriptor).ng = function () {
  return this.h10_1;
};
protoOf(JsonArrayDescriptor).sg = function (index) {
  return this.g10_1.sg(index);
};
protoOf(JsonArrayDescriptor).tg = function (name) {
  return this.g10_1.tg(name);
};
protoOf(JsonArrayDescriptor).ug = function (index) {
  return this.g10_1.ug(index);
};
protoOf(JsonArrayDescriptor).vg = function (index) {
  return this.g10_1.vg(index);
};
protoOf(JsonArrayDescriptor).wg = function (index) {
  return this.g10_1.wg(index);
};
protoOf(JsonArrayDescriptor).og = function () {
  return this.g10_1.og();
};
protoOf(JsonArrayDescriptor).jg = function () {
  return this.g10_1.jg();
};
protoOf(JsonArrayDescriptor).pg = function () {
  return this.g10_1.pg();
};
protoOf(JsonArrayDescriptor).qg = function () {
  return this.g10_1.qg();
};
protoOf(JsonArrayDescriptor).rg = function () {
  return this.g10_1.rg();
};
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance == null)
    new JsonArrayDescriptor();
  return JsonArrayDescriptor_instance;
}
function JsonArraySerializer() {
  JsonArraySerializer_instance = this;
  this.a10_1 = JsonArrayDescriptor_getInstance();
}
protoOf(JsonArraySerializer).jf = function () {
  return this.a10_1;
};
protoOf(JsonArraySerializer).i10 = function (encoder, value) {
  verify(encoder);
  ListSerializer(JsonElementSerializer_getInstance()).kf(encoder, value);
};
protoOf(JsonArraySerializer).kf = function (encoder, value) {
  return this.i10(encoder, value instanceof JsonArray ? value : THROW_CCE());
};
protoOf(JsonArraySerializer).lf = function (decoder) {
  verify_0(decoder);
  return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).lf(decoder));
};
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance == null)
    new JsonArraySerializer();
  return JsonArraySerializer_instance;
}
function defer(deferred) {
  return new defer$1(deferred);
}
function JsonPrimitiveSerializer() {
  JsonPrimitiveSerializer_instance = this;
  this.wz_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
}
protoOf(JsonPrimitiveSerializer).jf = function () {
  return this.wz_1;
};
protoOf(JsonPrimitiveSerializer).j10 = function (encoder, value) {
  verify(encoder);
  var tmp;
  if (value instanceof JsonNull) {
    encoder.wj(JsonNullSerializer_getInstance(), JsonNull_getInstance());
    tmp = Unit_instance;
  } else {
    var tmp_0 = JsonLiteralSerializer_getInstance();
    encoder.wj(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
    tmp = Unit_instance;
  }
  return tmp;
};
protoOf(JsonPrimitiveSerializer).kf = function (encoder, value) {
  return this.j10(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
};
protoOf(JsonPrimitiveSerializer).lf = function (decoder) {
  var result = asJsonDecoder(decoder).kz();
  if (!(result instanceof JsonPrimitive))
    throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString_0(getKClassFromExpression(result)), toString_0(result));
  return result;
};
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance == null)
    new JsonPrimitiveSerializer();
  return JsonPrimitiveSerializer_instance;
}
function JsonNullSerializer() {
  JsonNullSerializer_instance = this;
  this.xz_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
}
protoOf(JsonNullSerializer).jf = function () {
  return this.xz_1;
};
protoOf(JsonNullSerializer).k10 = function (encoder, value) {
  verify(encoder);
  encoder.aj();
};
protoOf(JsonNullSerializer).kf = function (encoder, value) {
  return this.k10(encoder, value instanceof JsonNull ? value : THROW_CCE());
};
protoOf(JsonNullSerializer).lf = function (decoder) {
  verify_0(decoder);
  if (decoder.sh()) {
    throw new JsonDecodingException("Expected 'null' literal");
  }
  decoder.th();
  return JsonNull_getInstance();
};
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance == null)
    new JsonNullSerializer();
  return JsonNullSerializer_instance;
}
function JsonLiteralSerializer() {
  JsonLiteralSerializer_instance = this;
  this.yz_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
}
protoOf(JsonLiteralSerializer).jf = function () {
  return this.yz_1;
};
protoOf(JsonLiteralSerializer).l10 = function (encoder, value) {
  verify(encoder);
  if (value.rz_1) {
    return encoder.jj(value.tz_1);
  }
  if (!(value.sz_1 == null)) {
    return encoder.kj(value.sz_1).jj(value.tz_1);
  }
  var tmp0_safe_receiver = toLongOrNull(value.tz_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.fj(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = toULongOrNull(value.tz_1);
  var tmp = tmp1_safe_receiver;
  if ((tmp == null ? null : new ULong(tmp)) == null)
    null;
  else {
    var tmp_0 = tmp1_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new ULong(tmp_0)).te_1;
    var tmp_1 = encoder.kj(serializer_0(Companion_getInstance()).jf());
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
    tmp_1.fj(tmp$ret$1);
    return Unit_instance;
  }
  var tmp2_safe_receiver = toDoubleOrNull(value.tz_1);
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.hj(tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = toBooleanStrictOrNull(value.tz_1);
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.bj(tmp3_safe_receiver);
  }
  encoder.jj(value.tz_1);
};
protoOf(JsonLiteralSerializer).kf = function (encoder, value) {
  return this.l10(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
};
protoOf(JsonLiteralSerializer).lf = function (decoder) {
  var result = asJsonDecoder(decoder).kz();
  if (!(result instanceof JsonLiteral))
    throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString_0(getKClassFromExpression(result)), toString_0(result));
  return result;
};
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance == null)
    new JsonLiteralSerializer();
  return JsonLiteralSerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString_0(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString_0(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.m10_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
  return tmp0.n1();
}
function defer$o$_get_original_$ref_3cje7k() {
  return function (p0) {
    return _get_original__l7ku1m(p0);
  };
}
function defer$1($deferred) {
  this.m10_1 = lazy($deferred);
}
protoOf(defer$1).ng = function () {
  return _get_original__l7ku1m(this).ng();
};
protoOf(defer$1).og = function () {
  return _get_original__l7ku1m(this).og();
};
protoOf(defer$1).qg = function () {
  return _get_original__l7ku1m(this).qg();
};
protoOf(defer$1).sg = function (index) {
  return _get_original__l7ku1m(this).sg(index);
};
protoOf(defer$1).tg = function (name) {
  return _get_original__l7ku1m(this).tg(name);
};
protoOf(defer$1).ug = function (index) {
  return _get_original__l7ku1m(this).ug(index);
};
protoOf(defer$1).vg = function (index) {
  return _get_original__l7ku1m(this).vg(index);
};
protoOf(defer$1).wg = function (index) {
  return _get_original__l7ku1m(this).wg(index);
};
function JsonEncoder() {
}
function Composer(writer) {
  this.n10_1 = writer;
  this.o10_1 = true;
}
protoOf(Composer).p10 = function () {
  this.o10_1 = true;
};
protoOf(Composer).q10 = function () {
  return Unit_instance;
};
protoOf(Composer).r10 = function () {
  this.o10_1 = false;
};
protoOf(Composer).s10 = function () {
  this.o10_1 = false;
};
protoOf(Composer).t10 = function () {
  return Unit_instance;
};
protoOf(Composer).u10 = function (v) {
  return this.n10_1.v10(v);
};
protoOf(Composer).w10 = function (v) {
  return this.n10_1.x10(v);
};
protoOf(Composer).y10 = function (v) {
  return this.n10_1.x10(v.toString());
};
protoOf(Composer).z10 = function (v) {
  return this.n10_1.x10(v.toString());
};
protoOf(Composer).a11 = function (v) {
  return this.n10_1.b11(fromInt(v));
};
protoOf(Composer).c11 = function (v) {
  return this.n10_1.b11(fromInt(v));
};
protoOf(Composer).d11 = function (v) {
  return this.n10_1.b11(fromInt(v));
};
protoOf(Composer).e11 = function (v) {
  return this.n10_1.b11(v);
};
protoOf(Composer).f11 = function (v) {
  return this.n10_1.x10(v.toString());
};
protoOf(Composer).g11 = function (value) {
  return this.n10_1.h11(value);
};
function Composer_0(sb, json) {
  return json.yx_1.wy_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
}
function ComposerForUnsignedNumbers(writer, forceQuoting) {
  Composer.call(this, writer);
  this.k11_1 = forceQuoting;
}
protoOf(ComposerForUnsignedNumbers).d11 = function (v) {
  if (this.k11_1) {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
    this.g11(UInt__toString_impl_dbgl21(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
    this.w10(UInt__toString_impl_dbgl21(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).e11 = function (v) {
  if (this.k11_1) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
    this.g11(ULong__toString_impl_f9au7k(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
    this.w10(ULong__toString_impl_f9au7k(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).a11 = function (v) {
  if (this.k11_1) {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
    this.g11(UByte__toString_impl_v72jg(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
    this.w10(UByte__toString_impl_v72jg(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).c11 = function (v) {
  if (this.k11_1) {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$0 = _UShort___init__impl__jigrne(v);
    this.g11(UShort__toString_impl_edaoee(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$1 = _UShort___init__impl__jigrne(v);
    this.w10(UShort__toString_impl_edaoee(tmp$ret$1));
  }
};
function ComposerForUnquotedLiterals(writer, forceQuoting) {
  Composer.call(this, writer);
  this.n11_1 = forceQuoting;
}
protoOf(ComposerForUnquotedLiterals).g11 = function (value) {
  if (this.n11_1) {
    protoOf(Composer).g11.call(this, value);
  } else {
    protoOf(Composer).w10.call(this, value);
  }
};
function ComposerWithPrettyPrint(writer, json) {
  Composer.call(this, writer);
  this.q11_1 = json;
  this.r11_1 = 0;
}
protoOf(ComposerWithPrettyPrint).p10 = function () {
  this.o10_1 = true;
  this.r11_1 = this.r11_1 + 1 | 0;
};
protoOf(ComposerWithPrettyPrint).q10 = function () {
  this.r11_1 = this.r11_1 - 1 | 0;
};
protoOf(ComposerWithPrettyPrint).r10 = function () {
  this.o10_1 = false;
  this.w10('\n');
  // Inline function 'kotlin.repeat' call
  var times = this.r11_1;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.w10(this.q11_1.yx_1.yy_1);
    }
     while (inductionVariable < times);
};
protoOf(ComposerWithPrettyPrint).s10 = function () {
  if (this.o10_1)
    this.o10_1 = false;
  else {
    this.r10();
  }
};
protoOf(ComposerWithPrettyPrint).t10 = function () {
  this.u10(_Char___init__impl__6a9atx(32));
};
function readIfAbsent($this, descriptor, index) {
  $this.t11_1 = (!descriptor.wg(index) && descriptor.vg(index).jg());
  return $this.t11_1;
}
function JsonElementMarker$readIfAbsent$ref(p0) {
  var l = function (_this__u8e3s4, p0_0) {
    var tmp0 = p0;
    return readIfAbsent(tmp0, _this__u8e3s4, p0_0);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
function JsonElementMarker(descriptor) {
  var tmp = this;
  tmp.s11_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
  this.t11_1 = false;
}
protoOf(JsonElementMarker).u11 = function (index) {
  this.s11_1.ho(index);
};
protoOf(JsonElementMarker).v11 = function () {
  return this.s11_1.io();
};
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.w11('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.ny_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingCommas = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.x11('Unexpected special floating-point value ' + toString_0(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
function JsonEncodingException(message) {
  JsonException.call(this, message);
  captureStack(this, JsonEncodingException);
}
function InvalidKeyKindException(keyDescriptor) {
  return new JsonEncodingException("Value of type '" + keyDescriptor.ng() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.og().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function JsonDecodingException(message) {
  JsonException.call(this, message);
  captureStack(this, JsonDecodingException);
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString_0(minify(input, offset)));
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function UnknownKeyException(key, input) {
  return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString_0(minify(input))));
}
function InvalidFloatingPointEncoded(value, output) {
  return new JsonEncodingException('Unexpected special floating-point value ' + toString_0(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString_0(minify(output))));
}
function JsonException(message) {
  SerializationException_init_$Init$(message, this);
  captureStack(this, JsonException);
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString_0(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString_0(minify(output)));
}
function JsonDecodingException_1(offset, message) {
  return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString_0(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  var tmp2 = coerceAtLeast(start_0, 0);
  // Inline function 'kotlin.text.substring' call
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString_0(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
}
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.tg(name);
  if (!(index === -3))
    return index;
  if (!json.yx_1.dz_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.sg(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.og(), CLASS_getInstance()) ? json.yx_1.ez_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.z11(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.yx_1.fz_1 && equals(descriptor.og(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).q1(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.z11(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap_init_$Create$();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.qg();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = _this__u8e3s4.ug(i);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.h();
      while (_iterator__ex2g4s.i()) {
        var element = _iterator__ex2g4s.j();
        if (element instanceof JsonNames) {
          destination.f(element);
        }
      }
      var tmp0_safe_receiver = singleOrNull(destination);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a12_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.sg(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.b12(_this__u8e3s4, i, _this__u8e3s4.sg(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (builder.l()) {
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.og(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).o1(name)) {
    throw new JsonException("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.sg(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.sg(getValue(_this__u8e3s4, name)) + ' in ' + toString_0($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.u1(name, index);
}
function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
  return function () {
    return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
  };
}
function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
  return function () {
    var tmp = 0;
    var tmp_0 = $this_serializationNamesIndices.qg();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = $this_serializationNamesIndices.sg(tmp_2);
      tmp_1[tmp_2] = $strategy.b12($this_serializationNamesIndices, tmp_2, baseName);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new Key();
    JsonSerializationNamesKey = new Key();
  }
}
function Tombstone() {
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
function resize($this) {
  var newSize = imul($this.e12_1, 2);
  $this.c12_1 = copyOf($this.c12_1, newSize);
  $this.d12_1 = copyOf_0($this.d12_1, newSize);
}
function JsonPath() {
  var tmp = this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.c12_1 = Array(8);
  var tmp_0 = this;
  var tmp_1 = 0;
  var tmp_2 = new Int32Array(8);
  while (tmp_1 < 8) {
    tmp_2[tmp_1] = -1;
    tmp_1 = tmp_1 + 1 | 0;
  }
  tmp_0.d12_1 = tmp_2;
  this.e12_1 = -1;
}
protoOf(JsonPath).f12 = function (sd) {
  this.e12_1 = this.e12_1 + 1 | 0;
  var depth = this.e12_1;
  if (depth === this.c12_1.length) {
    resize(this);
  }
  this.c12_1[depth] = sd;
};
protoOf(JsonPath).g12 = function (index) {
  this.d12_1[this.e12_1] = index;
};
protoOf(JsonPath).h12 = function (key) {
  var tmp;
  if (!(this.d12_1[this.e12_1] === -2)) {
    this.e12_1 = this.e12_1 + 1 | 0;
    tmp = this.e12_1 === this.c12_1.length;
  } else {
    tmp = false;
  }
  if (tmp) {
    resize(this);
  }
  this.c12_1[this.e12_1] = key;
  this.d12_1[this.e12_1] = -2;
};
protoOf(JsonPath).i12 = function () {
  if (this.d12_1[this.e12_1] === -2) {
    this.c12_1[this.e12_1] = Tombstone_instance;
  }
};
protoOf(JsonPath).j12 = function () {
  var depth = this.e12_1;
  if (this.d12_1[depth] === -2) {
    this.d12_1[depth] = -1;
    this.e12_1 = this.e12_1 - 1 | 0;
  }
  if (!(this.e12_1 === -1)) {
    this.e12_1 = this.e12_1 - 1 | 0;
  }
};
protoOf(JsonPath).k12 = function () {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.l6('$');
  // Inline function 'kotlin.repeat' call
  var times = this.e12_1 + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = this.c12_1[index];
      if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
        if (equals(element.og(), LIST_getInstance())) {
          if (!(this.d12_1[index] === -1)) {
            this_0.l6('[');
            this_0.j9(this.d12_1[index]);
            this_0.l6(']');
          }
        } else {
          var idx = this.d12_1[index];
          if (idx >= 0) {
            this_0.l6('.');
            this_0.l6(element.sg(idx));
          }
        }
      } else {
        if (!(element === Tombstone_instance)) {
          this_0.l6('[');
          this_0.l6("'");
          this_0.k6(element);
          this_0.l6("'");
          this_0.l6(']');
        }
      }
    }
     while (inductionVariable < times);
  return this_0.toString();
};
protoOf(JsonPath).toString = function () {
  return this.k12();
};
function encodeByWriter(json, writer, serializer, value) {
  var tmp = WriteMode_OBJ_getInstance();
  // Inline function 'kotlin.arrayOfNulls' call
  var size = get_entries().k();
  var tmp$ret$0 = Array(size);
  var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
  encoder.wj(serializer, value);
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.u12_1.y12(6);
  if ($this.u12_1.z12() === 4) {
    $this.u12_1.x11('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap_init_$Create$();
  $l$loop: while ($this.u12_1.a13()) {
    var key = $this.v12_1 ? $this.u12_1.c13() : $this.u12_1.b13();
    $this.u12_1.y12(5);
    var element = $this.d13();
    // Inline function 'kotlin.collections.set' call
    result.u1(key, element);
    lastToken = $this.u12_1.e13();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.u12_1.x11('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.u12_1.y12(7);
  } else if (lastToken === 4) {
    if (!$this.w12_1) {
      invalidTrailingComma($this.u12_1);
    }
    $this.u12_1.y12(7);
  }
  return new JsonObject(result);
}
function readObject_0($this, _this__u8e3s4, $completion) {
  var tmp = new $readObjectCOROUTINE$($this, _this__u8e3s4, $completion);
  tmp.z6_1 = Unit_instance;
  tmp.a7_1 = null;
  return tmp.f7();
}
function readArray($this) {
  var lastToken = $this.u12_1.e13();
  if ($this.u12_1.z12() === 4) {
    $this.u12_1.x11('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList_init_$Create$();
  while ($this.u12_1.a13()) {
    var element = $this.d13();
    result.f(element);
    lastToken = $this.u12_1.e13();
    if (!(lastToken === 4)) {
      var tmp0 = $this.u12_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.ny_1;
      if (!condition) {
        var tmp$ret$1 = 'Expected end of the array or comma';
        tmp0.x11(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.u12_1.y12(9);
  } else if (lastToken === 4) {
    if (!$this.w12_1) {
      invalidTrailingComma($this.u12_1, 'array');
    }
    $this.u12_1.y12(9);
  }
  return new JsonArray(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.v12_1 || !isString) {
    tmp = $this.u12_1.c13();
  } else {
    tmp = $this.u12_1.b13();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new JsonLiteral(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
  this.b14_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(JsonTreeReader$readDeepRecursive$slambda).f14 = function ($this$DeepRecursiveFunction, it, $completion) {
  var tmp = this.g14($this$DeepRecursiveFunction, it, $completion);
  tmp.z6_1 = Unit_instance;
  tmp.a7_1 = null;
  return tmp.f7();
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).l7 = function (p1, p2, $completion) {
  var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
  return this.f14(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).f7 = function () {
  var suspendResult = this.z6_1;
  $sm: do
    try {
      var tmp = this.x6_1;
      switch (tmp) {
        case 0:
          this.y6_1 = 3;
          var tmp0_subject = this.b14_1.u12_1.z12();
          if (tmp0_subject === 1) {
            this.e14_1 = readValue(this.b14_1, true);
            this.x6_1 = 2;
            continue $sm;
          } else {
            if (tmp0_subject === 0) {
              this.e14_1 = readValue(this.b14_1, false);
              this.x6_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject === 6) {
                this.x6_1 = 1;
                suspendResult = readObject_0(this.b14_1, this.c14_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject === 8) {
                  this.e14_1 = readArray(this.b14_1);
                  this.x6_1 = 2;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  this.b14_1.u12_1.x11("Can't begin reading element, unexpected token");
                }
              }
            }
          }

          break;
        case 1:
          this.e14_1 = suspendResult;
          this.x6_1 = 2;
          continue $sm;
        case 2:
          return this.e14_1;
        case 3:
          throw this.a7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.y6_1 === 3) {
        throw e;
      } else {
        this.x6_1 = this.y6_1;
        this.a7_1 = e;
      }
    }
   while (true);
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).g14 = function ($this$DeepRecursiveFunction, it, completion) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this.b14_1, completion);
  i.c14_1 = $this$DeepRecursiveFunction;
  i.d14_1 = it;
  return i;
};
function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
  var l = function ($this$DeepRecursiveFunction, it, $completion) {
    return i.f14($this$DeepRecursiveFunction, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function $readObjectCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n13_1 = _this__u8e3s4;
  this.o13_1 = _this__u8e3s4_0;
}
protoOf($readObjectCOROUTINE$).f7 = function () {
  var suspendResult = this.z6_1;
  $sm: do
    try {
      var tmp = this.x6_1;
      switch (tmp) {
        case 0:
          this.y6_1 = 5;
          this.q13_1 = this.n13_1;
          this.r13_1 = this.q13_1.u12_1.y12(6);
          if (this.q13_1.u12_1.z12() === 4) {
            this.q13_1.u12_1.x11('Unexpected leading comma');
          }

          var tmp_0 = this;
          tmp_0.p13_1 = LinkedHashMap_init_$Create$();
          this.x6_1 = 1;
          continue $sm;
        case 1:
          if (!this.q13_1.u12_1.a13()) {
            this.x6_1 = 4;
            continue $sm;
          }

          this.s13_1 = this.q13_1.v12_1 ? this.q13_1.u12_1.c13() : this.q13_1.u12_1.b13();
          this.q13_1.u12_1.y12(5);
          this.x6_1 = 2;
          suspendResult = this.o13_1.ad(Unit_instance, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var element = suspendResult;
          var tmp0 = this.p13_1;
          var key = this.s13_1;
          tmp0.u1(key, element);
          this.r13_1 = this.q13_1.u12_1.e13();
          var tmp0_subject = this.r13_1;
          if (tmp0_subject === 4) {
            this.x6_1 = 3;
            continue $sm;
          } else {
            if (tmp0_subject === 7) {
              this.x6_1 = 4;
              continue $sm;
            } else {
              this.q13_1.u12_1.x11('Expected end of the object or comma');
            }
          }

          break;
        case 3:
          this.x6_1 = 1;
          continue $sm;
        case 4:
          if (this.r13_1 === 6) {
            this.q13_1.u12_1.y12(7);
          } else if (this.r13_1 === 4) {
            if (!this.q13_1.w12_1) {
              invalidTrailingComma(this.q13_1.u12_1);
            }
            this.q13_1.u12_1.y12(7);
          }

          return new JsonObject(this.p13_1);
        case 5:
          throw this.a7_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.y6_1 === 5) {
        throw e;
      } else {
        this.x6_1 = this.y6_1;
        this.a7_1 = e;
      }
    }
   while (true);
};
function JsonTreeReader(configuration, lexer) {
  this.u12_1 = lexer;
  this.v12_1 = configuration.uy_1;
  this.w12_1 = configuration.gz_1;
  this.x12_1 = 0;
}
protoOf(JsonTreeReader).d13 = function () {
  var token = this.u12_1.z12();
  var tmp;
  if (token === 1) {
    tmp = readValue(this, true);
  } else if (token === 0) {
    tmp = readValue(this, false);
  } else if (token === 6) {
    var tmp_0;
    this.x12_1 = this.x12_1 + 1 | 0;
    if (this.x12_1 === 200) {
      tmp_0 = readDeepRecursive(this);
    } else {
      tmp_0 = readObject(this);
    }
    var result = tmp_0;
    this.x12_1 = this.x12_1 - 1 | 0;
    tmp = result;
  } else if (token === 8) {
    tmp = readArray(this);
  } else {
    this.u12_1.x11('Cannot read Json element because of unexpected ' + tokenDescription(token));
  }
  return tmp;
};
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.rg().h();
  while (_iterator__ex2g4s.i()) {
    var annotation = _iterator__ex2g4s.j();
    if (annotation instanceof JsonClassDiscriminator)
      return annotation.h14_1;
  }
  return json.yx_1.bz_1;
}
function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
  if (!(serializer instanceof SealedClassSerializer))
    return Unit_instance;
  if (jsonCachedSerialNames(actualSerializer.jf()).k1(classDiscriminator)) {
    var baseName = serializer.jf().ng();
    var actualName = actualSerializer.jf().ng();
    // Inline function 'kotlin.error' call
    var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
}
function checkKind(kind) {
  if (kind instanceof ENUM) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException_init_$Create$(toString_0(message));
  }
  if (kind instanceof PrimitiveKind) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException_init_$Create$(toString_0(message_0));
  }
  if (kind instanceof PolymorphicKind) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException_init_$Create$(toString_0(message_1));
  }
}
function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
  return validateIfSealed(serializer, actualSerializer, classDiscriminator);
}
function Key() {
}
function DescriptorSchemaCache() {
  this.y11_1 = createMapForCache(16);
}
protoOf(DescriptorSchemaCache).i14 = function (descriptor, key, value) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = this.y11_1;
  var value_0 = this_0.q1(descriptor);
  var tmp;
  if (value_0 == null) {
    var answer = createMapForCache(2);
    this_0.u1(descriptor, answer);
    tmp = answer;
  } else {
    tmp = value_0;
  }
  var tmp0 = tmp;
  var tmp2 = key instanceof Key ? key : THROW_CCE();
  // Inline function 'kotlin.collections.set' call
  var value_1 = !(value == null) ? value : THROW_CCE();
  tmp0.u1(tmp2, value_1);
};
protoOf(DescriptorSchemaCache).z11 = function (descriptor, key, defaultValue) {
  var tmp0_safe_receiver = this.j14(descriptor, key);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var value = defaultValue();
  this.i14(descriptor, key, value);
  return value;
};
protoOf(DescriptorSchemaCache).j14 = function (descriptor, key) {
  var tmp0_safe_receiver = this.y11_1.q1(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = tmp0_safe_receiver.q1(key instanceof Key ? key : THROW_CCE());
  }
  var tmp_0 = tmp;
  return !(tmp_0 == null) ? tmp_0 : null;
};
function DiscriminatorHolder(discriminatorToSkip) {
  this.k14_1 = discriminatorToSkip;
}
function trySkip($this, _this__u8e3s4, unknownKey) {
  if (_this__u8e3s4 == null)
    return false;
  if (_this__u8e3s4.k14_1 === unknownKey) {
    _this__u8e3s4.k14_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.wi(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.hy_1.z12() === 4) {
    $this.hy_1.x11('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.jy_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.jy_1 === -1)) {
      hasComma = $this.hy_1.m14();
    }
  } else {
    $this.hy_1.l14(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.hy_1.a13()) {
    if (decodingKey) {
      if ($this.jy_1 === -1) {
        var tmp0 = $this.hy_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.ny_1;
        if (!condition) {
          var tmp$ret$0 = 'Unexpected leading comma';
          tmp0.x11(tmp$ret$0, position);
        }
      } else {
        var tmp0_0 = $this.hy_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.ny_1;
        if (!condition_0) {
          var tmp$ret$2 = 'Expected comma after the key-value pair';
          tmp0_0.x11(tmp$ret$2, position_0);
        }
      }
    }
    $this.jy_1 = $this.jy_1 + 1 | 0;
    tmp = $this.jy_1;
  } else {
    if (hasComma && !$this.fy_1.yx_1.gz_1) {
      invalidTrailingComma($this.hy_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.fy_1;
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.wg(index);
    var elementDescriptor = descriptor.vg(index);
    var tmp;
    if (isOptional && !elementDescriptor.jg()) {
      tmp = $this.hy_1.n14(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.og(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.jg()) {
        tmp_0 = $this.hy_1.n14(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.hy_1.o14($this.ly_1.uy_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.yx_1.xy_1 && elementDescriptor.jg();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.hy_1.b13();
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.hy_1.m14();
  while ($this.hy_1.a13()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.hy_1.l14(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.fy_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.ly_1.zy_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.hy_1.m14();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.my_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.u11(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, key);
    }
  }
  if (hasComma && !$this.fy_1.yx_1.gz_1) {
    invalidTrailingComma($this.hy_1);
  }
  var tmp1_safe_receiver = $this.my_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.v11();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, key) {
  if ($this.ly_1.ty_1 || trySkip($this, $this.ky_1, key)) {
    $this.hy_1.q14($this.ly_1.uy_1);
  } else {
    $this.hy_1.p14(key);
  }
  return $this.hy_1.m14();
}
function decodeListIndex($this) {
  var hasComma = $this.hy_1.m14();
  var tmp;
  if ($this.hy_1.a13()) {
    if (!($this.jy_1 === -1) && !hasComma) {
      $this.hy_1.x11('Expected end of the array or comma');
    }
    $this.jy_1 = $this.jy_1 + 1 | 0;
    tmp = $this.jy_1;
  } else {
    if (hasComma && !$this.fy_1.yx_1.gz_1) {
      invalidTrailingComma($this.hy_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.ly_1.uy_1) {
    tmp = $this.hy_1.s14();
  } else {
    tmp = $this.hy_1.r14();
  }
  return tmp;
}
function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
  AbstractDecoder.call(this);
  this.fy_1 = json;
  this.gy_1 = mode;
  this.hy_1 = lexer;
  this.iy_1 = this.fy_1.ui();
  this.jy_1 = -1;
  this.ky_1 = discriminatorHolder;
  this.ly_1 = this.fy_1.yx_1;
  this.my_1 = this.ly_1.xy_1 ? null : new JsonElementMarker(descriptor);
}
protoOf(StreamingJsonDecoder).jz = function () {
  return this.fy_1;
};
protoOf(StreamingJsonDecoder).ui = function () {
  return this.iy_1;
};
protoOf(StreamingJsonDecoder).kz = function () {
  return (new JsonTreeReader(this.fy_1.yx_1, this.hy_1)).d13();
};
protoOf(StreamingJsonDecoder).fi = function (deserializer) {
  try {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = this.fy_1.yx_1.az_1;
    }
    if (tmp) {
      return deserializer.lf(this);
    }
    var discriminator = classDiscriminator(deserializer.jf(), this.fy_1);
    var tmp0_elvis_lhs = this.hy_1.t14(discriminator, this.ly_1.uy_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp2 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
        var tmp_1;
        if (!(tmp2 instanceof AbstractPolymorphicSerializer)) {
          tmp_1 = true;
        } else {
          tmp_1 = this.jz().yx_1.az_1;
        }
        if (tmp_1) {
          tmp$ret$0 = tmp2.lf(this);
          break $l$block;
        }
        var discriminator_0 = classDiscriminator(tmp2.jf(), this.jz());
        var tmp0 = this.kz();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName = tmp2.jf().ng();
        if (!(tmp0 instanceof JsonObject)) {
          var tmp_2 = getKClass(JsonObject).v7();
          var tmp_3 = getKClassFromExpression(tmp0).v7();
          var tmp$ret$1 = this.hy_1.oy_1.k12();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString_0(tmp0));
        }
        var jsonTree = tmp0;
        var tmp0_safe_receiver = jsonTree.nz(discriminator_0);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
        var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
        var tmp_4;
        try {
          tmp_4 = findPolymorphicSerializer(tmp2, this, type);
        } catch ($p) {
          var tmp_5;
          if ($p instanceof SerializationException) {
            var it = $p;
            throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
          } else {
            throw $p;
          }
        }
        var tmp_6 = tmp_4;
        var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
        tmp$ret$0 = readPolymorphicJson(this.jz(), discriminator_0, jsonTree, actualSerializer);
      }
      return tmp$ret$0;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var type_0 = tmp_0;
    var tmp_7;
    try {
      tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
    } catch ($p) {
      var tmp_8;
      if ($p instanceof SerializationException) {
        var it_0 = $p;
        var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
        var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
        this.hy_1.x11(message, VOID, hint);
      } else {
        throw $p;
      }
      tmp_7 = tmp_8;
    }
    var tmp_9 = tmp_7;
    var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
    this.ky_1 = new DiscriminatorHolder(discriminator);
    return actualSerializer_0.lf(this);
  } catch ($p) {
    if ($p instanceof MissingFieldException) {
      var e = $p;
      if (contains_0(ensureNotNull(e.message), 'at path'))
        throw e;
      throw new MissingFieldException(e.dg_1, plus(e.message, ' at path: ') + this.hy_1.oy_1.k12(), e);
    } else {
      throw $p;
    }
  }
};
protoOf(StreamingJsonDecoder).gi = function (descriptor) {
  var newMode = switchMode(this.fy_1, descriptor);
  this.hy_1.oy_1.f12(descriptor);
  this.hy_1.l14(newMode.w14_1);
  checkLeadingComma(this);
  var tmp;
  switch (newMode.x1_1) {
    case 1:
    case 2:
    case 3:
      tmp = new StreamingJsonDecoder(this.fy_1, newMode, this.hy_1, descriptor, this.ky_1);
      break;
    default:
      var tmp_0;
      if (this.gy_1.equals(newMode) && this.fy_1.yx_1.xy_1) {
        tmp_0 = this;
      } else {
        tmp_0 = new StreamingJsonDecoder(this.fy_1, newMode, this.hy_1, descriptor, this.ky_1);
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).hi = function (descriptor) {
  if (this.fy_1.yx_1.ty_1 && descriptor.qg() === 0) {
    skipLeftoverElements(this, descriptor);
  }
  if (this.hy_1.m14() && !this.fy_1.yx_1.gz_1) {
    invalidTrailingComma(this.hy_1, '');
  }
  this.hy_1.l14(this.gy_1.x14_1);
  this.hy_1.oy_1.j12();
};
protoOf(StreamingJsonDecoder).sh = function () {
  var tmp;
  var tmp0_safe_receiver = this.my_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t11_1;
  if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
    tmp = !this.hy_1.y14();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).th = function () {
  return null;
};
protoOf(StreamingJsonDecoder).si = function (descriptor, index, deserializer, previousValue) {
  var isMapKey = this.gy_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
  if (isMapKey) {
    this.hy_1.oy_1.i12();
  }
  var value = protoOf(AbstractDecoder).si.call(this, descriptor, index, deserializer, previousValue);
  if (isMapKey) {
    this.hy_1.oy_1.h12(value);
  }
  return value;
};
protoOf(StreamingJsonDecoder).wi = function (descriptor) {
  var index;
  switch (this.gy_1.x1_1) {
    case 0:
      index = decodeObjectIndex(this, descriptor);
      break;
    case 2:
      index = decodeMapIndex(this);
      break;
    default:
      index = decodeListIndex(this);
      break;
  }
  if (!this.gy_1.equals(WriteMode_MAP_getInstance())) {
    this.hy_1.oy_1.g12(index);
  }
  return index;
};
protoOf(StreamingJsonDecoder).uh = function () {
  return this.hy_1.z14();
};
protoOf(StreamingJsonDecoder).vh = function () {
  var value = this.hy_1.vz();
  if (!equalsLong(value, fromInt(convertToByte(value)))) {
    this.hy_1.x11("Failed to parse byte for input '" + value.toString() + "'");
  }
  return convertToByte(value);
};
protoOf(StreamingJsonDecoder).wh = function () {
  var value = this.hy_1.vz();
  if (!equalsLong(value, fromInt(convertToShort(value)))) {
    this.hy_1.x11("Failed to parse short for input '" + value.toString() + "'");
  }
  return convertToShort(value);
};
protoOf(StreamingJsonDecoder).xh = function () {
  var value = this.hy_1.vz();
  if (!equalsLong(value, fromInt(convertToInt(value)))) {
    this.hy_1.x11("Failed to parse int for input '" + value.toString() + "'");
  }
  return convertToInt(value);
};
protoOf(StreamingJsonDecoder).yh = function () {
  return this.hy_1.vz();
};
protoOf(StreamingJsonDecoder).zh = function () {
  var tmp0 = this.hy_1;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c13();
    try {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$4 = toDouble(input);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.x11("Failed to parse type '" + 'float' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.fy_1.yx_1.cz_1;
  if (specialFp || isFinite(result))
    return result;
  throwInvalidFloatingPointDecoded(this.hy_1, result);
};
protoOf(StreamingJsonDecoder).ai = function () {
  var tmp0 = this.hy_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c13();
    try {
      tmp$ret$1 = toDouble(input);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.x11("Failed to parse type '" + 'double' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$1;
  var specialFp = this.fy_1.yx_1.cz_1;
  if (specialFp || isFinite_0(result))
    return result;
  throwInvalidFloatingPointDecoded(this.hy_1, result);
};
protoOf(StreamingJsonDecoder).bi = function () {
  var string = this.hy_1.c13();
  if (!(string.length === 1)) {
    this.hy_1.x11("Expected single char, but got '" + string + "'");
  }
  return charCodeAt(string, 0);
};
protoOf(StreamingJsonDecoder).ci = function () {
  var tmp;
  if (this.ly_1.uy_1) {
    tmp = this.hy_1.s14();
  } else {
    tmp = this.hy_1.b13();
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).di = function (descriptor) {
  return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.hy_1, this.fy_1) : protoOf(AbstractDecoder).di.call(this, descriptor);
};
function JsonDecoderForUnsignedTypes(lexer, json) {
  AbstractDecoder.call(this);
  this.a15_1 = lexer;
  this.b15_1 = json.ui();
}
protoOf(JsonDecoderForUnsignedTypes).ui = function () {
  return this.b15_1;
};
protoOf(JsonDecoderForUnsignedTypes).wi = function (descriptor) {
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString_0(message));
};
protoOf(JsonDecoderForUnsignedTypes).xh = function () {
  var tmp0 = this.a15_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c13();
    try {
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = toUInt(input);
      tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.x11("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).yh = function () {
  var tmp0 = this.a15_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c13();
    try {
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = toULong(input);
      tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.x11("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).vh = function () {
  var tmp0 = this.a15_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c13();
    try {
      // Inline function 'kotlin.UByte.toByte' call
      var this_0 = toUByte(input);
      tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.x11("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).wh = function () {
  var tmp0 = this.a15_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c13();
    try {
      // Inline function 'kotlin.UShort.toShort' call
      var this_0 = toUShort(input);
      tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.x11("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
  StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
  return $this;
}
function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
  return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
}
function encodeTypeInfo($this, discriminator, serialName) {
  $this.l12_1.r10();
  $this.jj(discriminator);
  $this.l12_1.u10(_Char___init__impl__6a9atx(58));
  $this.l12_1.t10();
  $this.jj(serialName);
}
function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
  AbstractEncoder.call(this);
  this.l12_1 = composer;
  this.m12_1 = json;
  this.n12_1 = mode;
  this.o12_1 = modeReuseCache;
  this.p12_1 = this.m12_1.ui();
  this.q12_1 = this.m12_1.yx_1;
  this.r12_1 = false;
  this.s12_1 = null;
  this.t12_1 = null;
  var i = this.n12_1.x1_1;
  if (!(this.o12_1 == null)) {
    if (!(this.o12_1[i] === null) || !(this.o12_1[i] === this)) {
      this.o12_1[i] = this;
    }
  }
}
protoOf(StreamingJsonEncoder).jz = function () {
  return this.m12_1;
};
protoOf(StreamingJsonEncoder).ui = function () {
  return this.p12_1;
};
protoOf(StreamingJsonEncoder).wj = function (serializer, value) {
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
    if (this.jz().yx_1.az_1) {
      serializer.kf(this, value);
      break $l$block;
    }
    var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
    var tmp;
    if (isPolymorphicSerializer) {
      tmp = !this.jz().yx_1.iz_1.equals(ClassDiscriminatorMode_NONE_getInstance());
    } else {
      var tmp_0;
      switch (this.jz().yx_1.iz_1.x1_1) {
        case 0:
        case 2:
          tmp_0 = false;
          break;
        case 1:
          // Inline function 'kotlin.let' call

          var it = serializer.jf().og();
          tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    }
    var needDiscriminator = tmp;
    var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.jf(), this.jz()) : null;
    var tmp_1;
    if (isPolymorphicSerializer) {
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      $l$block_0: {
        // Inline function 'kotlin.requireNotNull' call
        if (value == null) {
          var message = 'Value for serializer ' + toString_0(serializer.jf()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
          throw IllegalArgumentException_init_$Create$(toString_0(message));
        } else {
          break $l$block_0;
        }
      }
      var actual = findPolymorphicSerializer_0(casted, this, value);
      if (!(baseClassDiscriminator == null)) {
        access$validateIfSealed$tPolymorphicKt(serializer, actual, baseClassDiscriminator);
      }
      checkKind(actual.jf().og());
      tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
    } else {
      tmp_1 = serializer;
    }
    var actualSerializer = tmp_1;
    if (!(baseClassDiscriminator == null)) {
      var serialName = actualSerializer.jf().ng();
      this.s12_1 = baseClassDiscriminator;
      this.t12_1 = serialName;
    }
    actualSerializer.kf(this, value);
  }
};
protoOf(StreamingJsonEncoder).gi = function (descriptor) {
  var newMode = switchMode(this.m12_1, descriptor);
  if (!(newMode.w14_1 === _Char___init__impl__6a9atx(0))) {
    this.l12_1.u10(newMode.w14_1);
    this.l12_1.p10();
  }
  var discriminator = this.s12_1;
  if (!(discriminator == null)) {
    var tmp0_elvis_lhs = this.t12_1;
    encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.ng() : tmp0_elvis_lhs);
    this.s12_1 = null;
    this.t12_1 = null;
  }
  if (this.n12_1.equals(newMode)) {
    return this;
  }
  var tmp1_safe_receiver = this.o12_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.x1_1];
  return tmp2_elvis_lhs == null ? new StreamingJsonEncoder(this.l12_1, this.m12_1, newMode, this.o12_1) : tmp2_elvis_lhs;
};
protoOf(StreamingJsonEncoder).hi = function (descriptor) {
  if (!(this.n12_1.x14_1 === _Char___init__impl__6a9atx(0))) {
    this.l12_1.q10();
    this.l12_1.s10();
    this.l12_1.u10(this.n12_1.x14_1);
  }
};
protoOf(StreamingJsonEncoder).yi = function (descriptor, index) {
  switch (this.n12_1.x1_1) {
    case 1:
      if (!this.l12_1.o10_1) {
        this.l12_1.u10(_Char___init__impl__6a9atx(44));
      }

      this.l12_1.r10();
      break;
    case 2:
      if (!this.l12_1.o10_1) {
        var tmp = this;
        var tmp_0;
        if ((index % 2 | 0) === 0) {
          this.l12_1.u10(_Char___init__impl__6a9atx(44));
          this.l12_1.r10();
          tmp_0 = true;
        } else {
          this.l12_1.u10(_Char___init__impl__6a9atx(58));
          this.l12_1.t10();
          tmp_0 = false;
        }
        tmp.r12_1 = tmp_0;
      } else {
        this.r12_1 = true;
        this.l12_1.r10();
      }

      break;
    case 3:
      if (index === 0)
        this.r12_1 = true;
      if (index === 1) {
        this.l12_1.u10(_Char___init__impl__6a9atx(44));
        this.l12_1.t10();
        this.r12_1 = false;
      }

      break;
    default:
      if (!this.l12_1.o10_1) {
        this.l12_1.u10(_Char___init__impl__6a9atx(44));
      }

      this.l12_1.r10();
      this.jj(getJsonElementName(descriptor, this.m12_1, index));
      this.l12_1.u10(_Char___init__impl__6a9atx(58));
      this.l12_1.t10();
      break;
  }
  return true;
};
protoOf(StreamingJsonEncoder).kj = function (descriptor) {
  var tmp;
  if (get_isUnsignedNumber(descriptor)) {
    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
    var tmp_0;
    var tmp_1 = this.l12_1;
    if (tmp_1 instanceof ComposerForUnsignedNumbers) {
      tmp_0 = this.l12_1;
    } else {
      var tmp0 = this.l12_1.n10_1;
      var p1 = this.r12_1;
      tmp_0 = new ComposerForUnsignedNumbers(tmp0, p1);
    }
    var tmp$ret$1 = tmp_0;
    tmp = new StreamingJsonEncoder(tmp$ret$1, this.m12_1, this.n12_1, null);
  } else if (get_isUnquotedLiteral(descriptor)) {
    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
    var tmp_2;
    var tmp_3 = this.l12_1;
    if (tmp_3 instanceof ComposerForUnquotedLiterals) {
      tmp_2 = this.l12_1;
    } else {
      var tmp0_0 = this.l12_1.n10_1;
      var p1_0 = this.r12_1;
      tmp_2 = new ComposerForUnquotedLiterals(tmp0_0, p1_0);
    }
    var tmp$ret$3 = tmp_2;
    tmp = new StreamingJsonEncoder(tmp$ret$3, this.m12_1, this.n12_1, null);
  } else if (!(this.s12_1 == null)) {
    // Inline function 'kotlin.apply' call
    this.t12_1 = descriptor.ng();
    tmp = this;
  } else {
    tmp = protoOf(AbstractEncoder).kj.call(this, descriptor);
  }
  return tmp;
};
protoOf(StreamingJsonEncoder).aj = function () {
  this.l12_1.w10('null');
};
protoOf(StreamingJsonEncoder).bj = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.f11(value);
  }
};
protoOf(StreamingJsonEncoder).cj = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.a11(value);
  }
};
protoOf(StreamingJsonEncoder).dj = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.c11(value);
  }
};
protoOf(StreamingJsonEncoder).ej = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.d11(value);
  }
};
protoOf(StreamingJsonEncoder).fj = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.e11(value);
  }
};
protoOf(StreamingJsonEncoder).gj = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.y10(value);
  }
  if (!this.q12_1.cz_1 && !isFinite(value)) {
    throw InvalidFloatingPointEncoded(value, toString_0(this.l12_1.n10_1));
  }
};
protoOf(StreamingJsonEncoder).hj = function (value) {
  if (this.r12_1) {
    this.jj(value.toString());
  } else {
    this.l12_1.z10(value);
  }
  if (!this.q12_1.cz_1 && !isFinite_0(value)) {
    throw InvalidFloatingPointEncoded(value, toString_0(this.l12_1.n10_1));
  }
};
protoOf(StreamingJsonEncoder).ij = function (value) {
  this.jj(toString_1(value));
};
protoOf(StreamingJsonEncoder).jj = function (value) {
  return this.l12_1.g11(value);
};
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.pg() && get_unsignedNumberDescriptors().k1(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.pg() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).jf(), serializer_0(Companion_getInstance()).jf(), serializer_2(Companion_getInstance_1()).jf(), serializer_3(Companion_getInstance_2()).jf()]);
  }
}
function get_ESCAPE_STRINGS() {
  _init_properties_StringOps_kt__fcy1db();
  return ESCAPE_STRINGS;
}
var ESCAPE_STRINGS;
var ESCAPE_MARKERS;
function toHexChar(i) {
  _init_properties_StringOps_kt__fcy1db();
  var d = i & 15;
  var tmp;
  if (d < 10) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp = numberToChar(d + tmp$ret$0 | 0);
  } else {
    var tmp_0 = d - 10 | 0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
  }
  return tmp;
}
function printQuoted(_this__u8e3s4, value) {
  _init_properties_StringOps_kt__fcy1db();
  _this__u8e3s4.m6(_Char___init__impl__6a9atx(34));
  var lastPos = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(value) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt(value, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
        _this__u8e3s4.g9(value, lastPos, i);
        _this__u8e3s4.l6(get_ESCAPE_STRINGS()[c]);
        lastPos = i + 1 | 0;
      }
    }
     while (inductionVariable <= last);
  if (!(lastPos === 0))
    _this__u8e3s4.g9(value, lastPos, value.length);
  else
    _this__u8e3s4.l6(value);
  _this__u8e3s4.m6(_Char___init__impl__6a9atx(34));
}
function toBooleanStrictOrNull_0(_this__u8e3s4) {
  _init_properties_StringOps_kt__fcy1db();
  return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
}
var properties_initialized_StringOps_kt_wzaea7;
function _init_properties_StringOps_kt__fcy1db() {
  if (!properties_initialized_StringOps_kt_wzaea7) {
    properties_initialized_StringOps_kt_wzaea7 = true;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.apply' call
    var this_0 = Array(93);
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = toHexChar(c >> 12);
        var c2 = toHexChar(c >> 8);
        var c3 = toHexChar(c >> 4);
        var c4 = toHexChar(c);
        this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
      }
       while (inductionVariable <= 31);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(34);
    this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(92);
    this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(9);
    this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(8);
    this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(13);
    this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
    this_0[12] = '\\f';
    ESCAPE_STRINGS = this_0;
    // Inline function 'kotlin.apply' call
    var this_7 = new Int8Array(93);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 <= 31)
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_7[c_0] = 1;
      }
       while (inductionVariable_0 <= 31);
    // Inline function 'kotlin.code' call
    var this_8 = _Char___init__impl__6a9atx(34);
    var tmp = Char__toInt_impl_vasixd(this_8);
    // Inline function 'kotlin.code' call
    var this_9 = _Char___init__impl__6a9atx(34);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_9);
    this_7[tmp] = toByte(tmp$ret$1);
    // Inline function 'kotlin.code' call
    var this_10 = _Char___init__impl__6a9atx(92);
    var tmp_0 = Char__toInt_impl_vasixd(this_10);
    // Inline function 'kotlin.code' call
    var this_11 = _Char___init__impl__6a9atx(92);
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_11);
    this_7[tmp_0] = toByte(tmp$ret$3);
    // Inline function 'kotlin.code' call
    var this_12 = _Char___init__impl__6a9atx(9);
    var tmp_1 = Char__toInt_impl_vasixd(this_12);
    // Inline function 'kotlin.code' call
    var this_13 = _Char___init__impl__6a9atx(116);
    var tmp$ret$5 = Char__toInt_impl_vasixd(this_13);
    this_7[tmp_1] = toByte(tmp$ret$5);
    // Inline function 'kotlin.code' call
    var this_14 = _Char___init__impl__6a9atx(8);
    var tmp_2 = Char__toInt_impl_vasixd(this_14);
    // Inline function 'kotlin.code' call
    var this_15 = _Char___init__impl__6a9atx(98);
    var tmp$ret$7 = Char__toInt_impl_vasixd(this_15);
    this_7[tmp_2] = toByte(tmp$ret$7);
    // Inline function 'kotlin.code' call
    var this_16 = _Char___init__impl__6a9atx(10);
    var tmp_3 = Char__toInt_impl_vasixd(this_16);
    // Inline function 'kotlin.code' call
    var this_17 = _Char___init__impl__6a9atx(110);
    var tmp$ret$9 = Char__toInt_impl_vasixd(this_17);
    this_7[tmp_3] = toByte(tmp$ret$9);
    // Inline function 'kotlin.code' call
    var this_18 = _Char___init__impl__6a9atx(13);
    var tmp_4 = Char__toInt_impl_vasixd(this_18);
    // Inline function 'kotlin.code' call
    var this_19 = _Char___init__impl__6a9atx(114);
    var tmp$ret$11 = Char__toInt_impl_vasixd(this_19);
    this_7[tmp_4] = toByte(tmp$ret$11);
    // Inline function 'kotlin.code' call
    var this_20 = _Char___init__impl__6a9atx(102);
    var tmp$ret$12 = Char__toInt_impl_vasixd(this_20);
    this_7[12] = toByte(tmp$ret$12);
    ESCAPE_MARKERS = this_7;
  }
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.i15(tag), toString_0($this.j15()));
}
function AbstractJsonTreeDecoder(json, value, polymorphicDiscriminator) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  NamedValueDecoder.call(this);
  this.e15_1 = json;
  this.f15_1 = value;
  this.g15_1 = polymorphicDiscriminator;
  this.h15_1 = this.jz().yx_1;
}
protoOf(AbstractJsonTreeDecoder).jz = function () {
  return this.e15_1;
};
protoOf(AbstractJsonTreeDecoder).n1 = function () {
  return this.f15_1;
};
protoOf(AbstractJsonTreeDecoder).ui = function () {
  return this.jz().ui();
};
protoOf(AbstractJsonTreeDecoder).j15 = function () {
  var tmp0_safe_receiver = this.ov();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = this.k15(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? this.n1() : tmp1_elvis_lhs;
};
protoOf(AbstractJsonTreeDecoder).i15 = function (currentTag) {
  return this.qv() + ('.' + currentTag);
};
protoOf(AbstractJsonTreeDecoder).kz = function () {
  return this.j15();
};
protoOf(AbstractJsonTreeDecoder).fi = function (deserializer) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = this.jz().yx_1.az_1;
    }
    if (tmp) {
      tmp$ret$0 = deserializer.lf(this);
      break $l$block;
    }
    var discriminator = classDiscriminator(deserializer.jf(), this.jz());
    var tmp0 = this.kz();
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = deserializer.jf().ng();
    if (!(tmp0 instanceof JsonObject)) {
      var tmp_0 = getKClass(JsonObject).v7();
      var tmp_1 = getKClassFromExpression(tmp0).v7();
      var tmp$ret$1 = this.qv();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString_0(tmp0));
    }
    var jsonTree = tmp0;
    var tmp0_safe_receiver = jsonTree.nz(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
    var tmp_2;
    try {
      tmp_2 = findPolymorphicSerializer(deserializer, this, type);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof SerializationException) {
        var it = $p;
        throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
      } else {
        throw $p;
      }
    }
    var tmp_4 = tmp_2;
    var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
    tmp$ret$0 = readPolymorphicJson(this.jz(), discriminator, jsonTree, actualSerializer);
  }
  return tmp$ret$0;
};
protoOf(AbstractJsonTreeDecoder).pv = function (parentName, childName) {
  return childName;
};
protoOf(AbstractJsonTreeDecoder).gi = function (descriptor) {
  var currentObject = this.j15();
  var tmp0_subject = descriptor.og();
  var tmp;
  var tmp_0;
  if (equals(tmp0_subject, LIST_getInstance())) {
    tmp_0 = true;
  } else {
    tmp_0 = tmp0_subject instanceof PolymorphicKind;
  }
  if (tmp_0) {
    var tmp_1 = this.jz();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = descriptor.ng();
    if (!(currentObject instanceof JsonArray)) {
      var tmp_2 = getKClass(JsonArray).v7();
      var tmp_3 = getKClassFromExpression(currentObject).v7();
      var tmp$ret$0 = this.qv();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString_0(currentObject));
    }
    tmp = new JsonTreeListDecoder(tmp_1, currentObject);
  } else {
    if (equals(tmp0_subject, MAP_getInstance())) {
      // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
      var this_0 = this.jz();
      var keyDescriptor = carrierDescriptor(descriptor.vg(0), this_0.ui());
      var keyKind = keyDescriptor.og();
      var tmp_4;
      var tmp_5;
      if (keyKind instanceof PrimitiveKind) {
        tmp_5 = true;
      } else {
        tmp_5 = equals(keyKind, ENUM_getInstance());
      }
      if (tmp_5) {
        var tmp_6 = this.jz();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_0 = descriptor.ng();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_7 = getKClass(JsonObject).v7();
          var tmp_8 = getKClassFromExpression(currentObject).v7();
          var tmp$ret$3 = this.qv();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString_0(currentObject));
        }
        tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
      } else {
        if (this_0.yx_1.vy_1) {
          var tmp_9 = this.jz();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_1 = descriptor.ng();
          if (!(currentObject instanceof JsonArray)) {
            var tmp_10 = getKClass(JsonArray).v7();
            var tmp_11 = getKClassFromExpression(currentObject).v7();
            var tmp$ret$7 = this.qv();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString_0(currentObject));
          }
          tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
        } else {
          throw InvalidKeyKindException(keyDescriptor);
        }
      }
      tmp = tmp_4;
    } else {
      var tmp_12 = this.jz();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName_2 = descriptor.ng();
      if (!(currentObject instanceof JsonObject)) {
        var tmp_13 = getKClass(JsonObject).v7();
        var tmp_14 = getKClassFromExpression(currentObject).v7();
        var tmp$ret$12 = this.qv();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString_0(currentObject));
      }
      tmp = new JsonTreeDecoder(tmp_12, currentObject, this.g15_1);
    }
  }
  return tmp;
};
protoOf(AbstractJsonTreeDecoder).hi = function (descriptor) {
};
protoOf(AbstractJsonTreeDecoder).sh = function () {
  var tmp = this.j15();
  return !(tmp instanceof JsonNull);
};
protoOf(AbstractJsonTreeDecoder).l15 = function (tag) {
  return !(this.k15(tag) === JsonNull_getInstance());
};
protoOf(AbstractJsonTreeDecoder).sv = function (tag) {
  return this.l15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).m15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_booleanOrNull(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'boolean', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'boolean', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).tv = function (tag) {
  return this.m15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).n15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var result = get_int(literal);
      var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'byte', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'byte', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).uv = function (tag) {
  return this.n15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).o15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var result = get_int(literal);
      var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'short', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'short', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).vv = function (tag) {
  return this.o15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).p15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_int(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'int', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'int', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).wv = function (tag) {
  return this.p15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).q15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_long(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'long', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'long', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).xv = function (tag) {
  return this.q15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).r15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_float(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'float', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'float', tag);
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.jz().yx_1.cz_1;
  if (specialFp || isFinite(result))
    return result;
  throw InvalidFloatingPointDecoded(result, tag, toString_0(this.j15()));
};
protoOf(AbstractJsonTreeDecoder).yv = function (tag) {
  return this.r15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).s15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_double(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'double', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'double', tag);
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.jz().yx_1.cz_1;
  if (specialFp || isFinite_0(result))
    return result;
  throw InvalidFloatingPointDecoded(result, tag, toString_0(this.j15()));
};
protoOf(AbstractJsonTreeDecoder).zv = function (tag) {
  return this.s15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).t15 = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.k15(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).v7();
      var tmp_0 = getKClassFromExpression(value).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString_0(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = new Char(single(literal.pz()));
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'char', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1.x_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'char', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).aw = function (tag) {
  return this.t15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).u15 = function (tag) {
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
  // Inline function 'kotlinx.serialization.json.internal.cast' call
  var value = this.k15(tag);
  if (!(value instanceof JsonPrimitive)) {
    var tmp = getKClass(JsonPrimitive).v7();
    var tmp_0 = getKClassFromExpression(value).v7();
    var tmp$ret$0 = this.i15(tag);
    throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString_0(value));
  }
  var value_0 = value;
  if (!(value_0 instanceof JsonLiteral))
    throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.i15(tag), toString_0(this.j15()));
  if (!value_0.rz_1 && !this.jz().yx_1.uy_1) {
    throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.i15(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString_0(this.j15()));
  }
  return value_0.tz_1;
};
protoOf(AbstractJsonTreeDecoder).bw = function (tag) {
  return this.u15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).v15 = function (tag, inlineDescriptor) {
  var tmp;
  if (get_isUnsignedNumber(inlineDescriptor)) {
    var tmp_0 = this.jz();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    var tmp2 = this.k15(tag);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = inlineDescriptor.ng();
    if (!(tmp2 instanceof JsonPrimitive)) {
      var tmp_1 = getKClass(JsonPrimitive).v7();
      var tmp_2 = getKClassFromExpression(tmp2).v7();
      var tmp$ret$0 = this.i15(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString_0(tmp2));
    }
    var lexer = StringJsonLexer_0(tmp_0, tmp2.pz());
    tmp = new JsonDecoderForUnsignedTypes(lexer, this.jz());
  } else {
    tmp = protoOf(NamedValueDecoder).cw.call(this, tag, inlineDescriptor);
  }
  return tmp;
};
protoOf(AbstractJsonTreeDecoder).cw = function (tag, inlineDescriptor) {
  return this.v15((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
};
protoOf(AbstractJsonTreeDecoder).di = function (descriptor) {
  return !(this.ov() == null) ? protoOf(NamedValueDecoder).di.call(this, descriptor) : (new JsonPrimitiveDecoder(this.jz(), this.n1(), this.g15_1)).di(descriptor);
};
function coerceInputValue_0($this, descriptor, index, tag) {
  var tmp0 = $this.jz();
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.wg(index);
    var elementDescriptor = descriptor.vg(index);
    var tmp;
    if (isOptional && !elementDescriptor.jg()) {
      var tmp_0 = $this.k15(tag);
      tmp = tmp_0 instanceof JsonNull;
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.og(), ENUM_getInstance())) {
      var tmp_1;
      if (elementDescriptor.jg()) {
        var tmp_2 = $this.k15(tag);
        tmp_1 = tmp_2 instanceof JsonNull;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      var tmp_3 = $this.k15(tag);
      var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
      var tmp_4;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_4 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_4;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.yx_1.xy_1 && elementDescriptor.jg();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function absenceIsNull($this, descriptor, index) {
  $this.f16_1 = (!$this.jz().yx_1.xy_1 && !descriptor.wg(index) && descriptor.vg(index).jg());
  return $this.f16_1;
}
function JsonTreeDecoder(json, value, polymorphicDiscriminator, polyDescriptor) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
  AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
  this.c16_1 = value;
  this.d16_1 = polyDescriptor;
  this.e16_1 = 0;
  this.f16_1 = false;
}
protoOf(JsonTreeDecoder).n1 = function () {
  return this.c16_1;
};
protoOf(JsonTreeDecoder).wi = function (descriptor) {
  while (this.e16_1 < descriptor.qg()) {
    var _unary__edvuaz = this.e16_1;
    this.e16_1 = _unary__edvuaz + 1 | 0;
    var name = this.jv(descriptor, _unary__edvuaz);
    var index = this.e16_1 - 1 | 0;
    this.f16_1 = false;
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.n1();
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).o1(name)) {
      tmp_0 = true;
    } else {
      tmp_0 = absenceIsNull(this, descriptor, index);
    }
    if (tmp_0) {
      tmp = !this.h15_1.zy_1 || !coerceInputValue_0(this, descriptor, index, name);
    } else {
      tmp = false;
    }
    if (tmp) {
      return index;
    }
  }
  return -1;
};
protoOf(JsonTreeDecoder).sh = function () {
  return !this.f16_1 && protoOf(AbstractJsonTreeDecoder).sh.call(this);
};
protoOf(JsonTreeDecoder).kv = function (descriptor, index) {
  var strategy = namingStrategy(descriptor, this.jz());
  var baseName = descriptor.sg(index);
  if (strategy == null) {
    if (!this.h15_1.dz_1)
      return baseName;
    if (this.n1().r1().k1(baseName))
      return baseName;
  }
  var deserializationNamesMap_0 = deserializationNamesMap(this.jz(), descriptor);
  // Inline function 'kotlin.collections.find' call
  var tmp0 = this.n1().r1();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.h();
    while (_iterator__ex2g4s.i()) {
      var element = _iterator__ex2g4s.j();
      if (deserializationNamesMap_0.q1(element) === index) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var fallbackName = strategy == null ? null : strategy.b12(descriptor, index, baseName);
  return fallbackName == null ? baseName : fallbackName;
};
protoOf(JsonTreeDecoder).k15 = function (tag) {
  return getValue(this.n1(), tag);
};
protoOf(JsonTreeDecoder).gi = function (descriptor) {
  if (descriptor === this.d16_1) {
    var tmp = this.jz();
    var tmp2 = this.j15();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = this.d16_1.ng();
    if (!(tmp2 instanceof JsonObject)) {
      var tmp_0 = getKClass(JsonObject).v7();
      var tmp_1 = getKClassFromExpression(tmp2).v7();
      var tmp$ret$0 = this.qv();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString_0(tmp2));
    }
    return new JsonTreeDecoder(tmp, tmp2, this.g15_1, this.d16_1);
  }
  return protoOf(AbstractJsonTreeDecoder).gi.call(this, descriptor);
};
protoOf(JsonTreeDecoder).hi = function (descriptor) {
  var tmp;
  if (this.h15_1.ty_1) {
    tmp = true;
  } else {
    var tmp_0 = descriptor.og();
    tmp = tmp_0 instanceof PolymorphicKind;
  }
  if (tmp)
    return Unit_instance;
  var strategy = namingStrategy(descriptor, this.jz());
  var tmp_1;
  if (strategy == null && !this.h15_1.dz_1) {
    tmp_1 = jsonCachedSerialNames(descriptor);
  } else if (!(strategy == null)) {
    tmp_1 = deserializationNamesMap(this.jz(), descriptor).r1();
  } else {
    var tmp_2 = jsonCachedSerialNames(descriptor);
    var tmp0_safe_receiver = get_schemaCache(this.jz()).j14(descriptor, get_JsonDeserializationNamesKey());
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r1();
    var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
    tmp_1 = plus_0(tmp_2, tmp$ret$0);
  }
  var names = tmp_1;
  var _iterator__ex2g4s = this.n1().r1().h();
  while (_iterator__ex2g4s.i()) {
    var key = _iterator__ex2g4s.j();
    if (!names.k1(key) && !(key === this.g15_1)) {
      throw UnknownKeyException(key, this.n1().toString());
    }
  }
};
function JsonTreeListDecoder(json, value) {
  AbstractJsonTreeDecoder.call(this, json, value);
  this.m16_1 = value;
  this.n16_1 = this.m16_1.k();
  this.o16_1 = -1;
}
protoOf(JsonTreeListDecoder).n1 = function () {
  return this.m16_1;
};
protoOf(JsonTreeListDecoder).kv = function (descriptor, index) {
  return index.toString();
};
protoOf(JsonTreeListDecoder).k15 = function (tag) {
  return this.m16_1.m(toInt(tag));
};
protoOf(JsonTreeListDecoder).wi = function (descriptor) {
  while (this.o16_1 < (this.n16_1 - 1 | 0)) {
    this.o16_1 = this.o16_1 + 1 | 0;
    return this.o16_1;
  }
  return -1;
};
function JsonPrimitiveDecoder(json, value, polymorphicDiscriminator) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
  this.v16_1 = value;
  this.dw('primitive');
}
protoOf(JsonPrimitiveDecoder).n1 = function () {
  return this.v16_1;
};
protoOf(JsonPrimitiveDecoder).wi = function (descriptor) {
  return 0;
};
protoOf(JsonPrimitiveDecoder).k15 = function (tag) {
  // Inline function 'kotlin.require' call
  if (!(tag === 'primitive')) {
    var message = "This input can only handle primitives with 'primitive' tag";
    throw IllegalArgumentException_init_$Create$(toString_0(message));
  }
  return this.v16_1;
};
function JsonTreeMapDecoder(json, value) {
  JsonTreeDecoder.call(this, json, value);
  this.g17_1 = value;
  this.h17_1 = toList(this.g17_1.r1());
  this.i17_1 = imul(this.h17_1.k(), 2);
  this.j17_1 = -1;
}
protoOf(JsonTreeMapDecoder).n1 = function () {
  return this.g17_1;
};
protoOf(JsonTreeMapDecoder).kv = function (descriptor, index) {
  var i = index / 2 | 0;
  return this.h17_1.m(i);
};
protoOf(JsonTreeMapDecoder).wi = function (descriptor) {
  while (this.j17_1 < (this.i17_1 - 1 | 0)) {
    this.j17_1 = this.j17_1 + 1 | 0;
    return this.j17_1;
  }
  return -1;
};
protoOf(JsonTreeMapDecoder).k15 = function (tag) {
  return (this.j17_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.g17_1, tag);
};
protoOf(JsonTreeMapDecoder).hi = function (descriptor) {
};
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.jf())).fi(deserializer);
}
var WriteMode_OBJ_instance;
var WriteMode_LIST_instance;
var WriteMode_MAP_instance;
var WriteMode_POLY_OBJ_instance;
function values() {
  return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WriteMode_entriesInitialized;
function WriteMode_initEntries() {
  if (WriteMode_entriesInitialized)
    return Unit_instance;
  WriteMode_entriesInitialized = true;
  WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var $ENTRIES;
function WriteMode(name, ordinal, begin, end) {
  Enum.call(this, name, ordinal);
  this.w14_1 = begin;
  this.x14_1 = end;
}
function switchMode(_this__u8e3s4, desc) {
  var tmp0_subject = desc.og();
  var tmp;
  if (tmp0_subject instanceof PolymorphicKind) {
    tmp = WriteMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = WriteMode_LIST_getInstance();
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.vg(0), _this__u8e3s4.ui());
        var keyKind = keyDescriptor.og();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          tmp_0 = WriteMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.yx_1.vy_1) {
            tmp_0 = WriteMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = WriteMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.og(), CONTEXTUAL_getInstance())) {
    var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
    tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  } else if (_this__u8e3s4.pg()) {
    tmp = carrierDescriptor(_this__u8e3s4.vg(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function WriteMode_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_OBJ_instance;
}
function WriteMode_LIST_getInstance() {
  WriteMode_initEntries();
  return WriteMode_LIST_instance;
}
function WriteMode_MAP_getInstance() {
  WriteMode_initEntries();
  return WriteMode_MAP_instance;
}
function WriteMode_POLY_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_POLY_OBJ_instance;
}
function appendEscape($this, lastPosition, current) {
  $this.k17(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.k17(lastPosition, currentPosition);
  var result = $this.qy_1.toString();
  $this.qy_1.m9(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.py_1);
  $this.py_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.l17(), $this.ny_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.m17(currentPosition);
  if (currentPosition === -1) {
    $this.x11('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.l17();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.l17(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.x11("Invalid escaped char '" + toString_1(currentChar) + "'");
  }
  $this.qy_1.m6(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.ny_1 = startPos;
    $this.n17();
    if (($this.ny_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.x11('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.ny_1);
  }
  $this.qy_1.m6(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.x11("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.m17(start);
  if (current >= charSequenceLength($this.l17()) || current === -1) {
    $this.x11('EOF');
  }
  var tmp = $this.l17();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.code' call
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.x11("Expected valid boolean literal prefix, but had '" + $this.c13() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.l17()) - current | 0) < literalSuffix.length) {
    $this.x11('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charCodeAt(literalSuffix, i);
      var actual = charSequenceGet($this.l17(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.x11("Expected valid boolean literal prefix, but had '" + $this.c13() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.ny_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function AbstractJsonLexer() {
  this.ny_1 = 0;
  this.oy_1 = new JsonPath();
  this.py_1 = null;
  this.qy_1 = StringBuilder_init_$Create$();
}
protoOf(AbstractJsonLexer).n17 = function () {
};
protoOf(AbstractJsonLexer).m14 = function () {
  var current = this.o17();
  var source = this.l17();
  if (current >= charSequenceLength(source) || current === -1)
    return false;
  if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
    this.ny_1 = this.ny_1 + 1 | 0;
    return true;
  }
  return false;
};
protoOf(AbstractJsonLexer).p17 = function (c) {
  return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
};
protoOf(AbstractJsonLexer).ry = function () {
  var nextToken = this.e13();
  if (!(nextToken === 10)) {
    this.x11('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.l17(), this.ny_1 - 1 | 0)) + ' instead');
  }
};
protoOf(AbstractJsonLexer).y12 = function (expected) {
  var token = this.e13();
  if (!(token === expected)) {
    this.q17(expected);
  }
  return token;
};
protoOf(AbstractJsonLexer).r17 = function (expected) {
  if (this.ny_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
      var snapshot = this.ny_1;
      try {
        this.ny_1 = this.ny_1 - 1 | 0;
        tmp$ret$1 = this.c13();
        break $l$block;
      }finally {
        this.ny_1 = snapshot;
      }
    }
    var inputLiteral = tmp$ret$1;
    if (inputLiteral === 'null') {
      this.w11("Expected string literal but 'null' literal was found", this.ny_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
    }
  }
  this.q17(charToTokenClass(expected));
};
protoOf(AbstractJsonLexer).s17 = function (expectedToken, wasConsumed) {
  var expected = tokenDescription(expectedToken);
  var position = wasConsumed ? this.ny_1 - 1 | 0 : this.ny_1;
  var s = this.ny_1 === charSequenceLength(this.l17()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.l17(), position));
  this.x11('Expected ' + expected + ", but had '" + s + "' instead", position);
};
protoOf(AbstractJsonLexer).q17 = function (expectedToken, wasConsumed, $super) {
  wasConsumed = wasConsumed === VOID ? true : wasConsumed;
  return $super === VOID ? this.s17(expectedToken, wasConsumed) : $super.s17.call(this, expectedToken, wasConsumed);
};
protoOf(AbstractJsonLexer).z12 = function () {
  var source = this.l17();
  var cpos = this.ny_1;
  $l$loop_0: while (true) {
    cpos = this.m17(cpos);
    if (cpos === -1)
      break $l$loop_0;
    var ch = charSequenceGet(source, cpos);
    if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
      cpos = cpos + 1 | 0;
      continue $l$loop_0;
    }
    this.ny_1 = cpos;
    return charToTokenClass(ch);
  }
  this.ny_1 = cpos;
  return 10;
};
protoOf(AbstractJsonLexer).n14 = function (doConsume) {
  var current = this.o17();
  current = this.m17(current);
  var len = charSequenceLength(this.l17()) - current | 0;
  if (len < 4 || current === -1)
    return false;
  var inductionVariable = 0;
  if (inductionVariable <= 3)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charCodeAt('null', i) === charSequenceGet(this.l17(), current + i | 0)))
        return false;
    }
     while (inductionVariable <= 3);
  if (len > 4 && charToTokenClass(charSequenceGet(this.l17(), current + 4 | 0)) === 0)
    return false;
  if (doConsume) {
    this.ny_1 = current + 4 | 0;
  }
  return true;
};
protoOf(AbstractJsonLexer).y14 = function (doConsume, $super) {
  doConsume = doConsume === VOID ? true : doConsume;
  return $super === VOID ? this.n14(doConsume) : $super.n14.call(this, doConsume);
};
protoOf(AbstractJsonLexer).o14 = function (isLenient) {
  var token = this.z12();
  var tmp;
  if (isLenient) {
    if (!(token === 1) && !(token === 0))
      return null;
    tmp = this.c13();
  } else {
    if (!(token === 1))
      return null;
    tmp = this.b13();
  }
  var string = tmp;
  this.py_1 = string;
  return string;
};
protoOf(AbstractJsonLexer).t17 = function () {
  this.py_1 = null;
};
protoOf(AbstractJsonLexer).u17 = function (startPos, endPos) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = this.l17();
  return toString_0(charSequenceSubSequence(this_0, startPos, endPos));
};
protoOf(AbstractJsonLexer).b13 = function () {
  if (!(this.py_1 == null)) {
    return takePeeked(this);
  }
  return this.r14();
};
protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
  var currentPosition = current;
  var lastPosition = startPosition;
  var char = charSequenceGet(source, currentPosition);
  var usedAppend = false;
  while (!(char === _Char___init__impl__6a9atx(34))) {
    if (char === _Char___init__impl__6a9atx(92)) {
      usedAppend = true;
      currentPosition = this.m17(appendEscape(this, lastPosition, currentPosition));
      if (currentPosition === -1) {
        this.x11('Unexpected EOF', currentPosition);
      }
      lastPosition = currentPosition;
    } else {
      currentPosition = currentPosition + 1 | 0;
      if (currentPosition >= charSequenceLength(source)) {
        usedAppend = true;
        this.k17(lastPosition, currentPosition);
        currentPosition = this.m17(currentPosition);
        if (currentPosition === -1) {
          this.x11('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      }
    }
    char = charSequenceGet(source, currentPosition);
  }
  var tmp;
  if (!usedAppend) {
    tmp = this.u17(lastPosition, currentPosition);
  } else {
    tmp = decodedString(this, lastPosition, currentPosition);
  }
  var string = tmp;
  this.ny_1 = currentPosition + 1 | 0;
  return string;
};
protoOf(AbstractJsonLexer).s14 = function () {
  var result = this.c13();
  if (result === 'null' && wasUnquotedString(this)) {
    this.x11("Unexpected 'null' value instead of string literal");
  }
  return result;
};
protoOf(AbstractJsonLexer).c13 = function () {
  if (!(this.py_1 == null)) {
    return takePeeked(this);
  }
  var current = this.o17();
  if (current >= charSequenceLength(this.l17()) || current === -1) {
    this.x11('EOF', current);
  }
  var token = charToTokenClass(charSequenceGet(this.l17(), current));
  if (token === 1) {
    return this.b13();
  }
  if (!(token === 0)) {
    this.x11('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.l17(), current)));
  }
  var usedAppend = false;
  while (charToTokenClass(charSequenceGet(this.l17(), current)) === 0) {
    current = current + 1 | 0;
    if (current >= charSequenceLength(this.l17())) {
      usedAppend = true;
      this.k17(this.ny_1, current);
      var eof = this.m17(current);
      if (eof === -1) {
        this.ny_1 = current;
        return decodedString(this, 0, 0);
      } else {
        current = eof;
      }
    }
  }
  var tmp;
  if (!usedAppend) {
    tmp = this.u17(this.ny_1, current);
  } else {
    tmp = decodedString(this, this.ny_1, current);
  }
  var result = tmp;
  this.ny_1 = current;
  return result;
};
protoOf(AbstractJsonLexer).k17 = function (fromIndex, toIndex) {
  this.qy_1.g9(this.l17(), fromIndex, toIndex);
};
protoOf(AbstractJsonLexer).q14 = function (allowLenientStrings) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var tokenStack = ArrayList_init_$Create$();
  var lastToken = this.z12();
  if (!(lastToken === 8) && !(lastToken === 6)) {
    this.c13();
    return Unit_instance;
  }
  $l$loop: while (true) {
    lastToken = this.z12();
    if (lastToken === 1) {
      if (allowLenientStrings)
        this.c13();
      else
        this.r14();
      continue $l$loop;
    }
    var tmp0_subject = lastToken;
    if (tmp0_subject === 8 || tmp0_subject === 6) {
      tokenStack.f(lastToken);
    } else if (tmp0_subject === 9) {
      if (!(last(tokenStack) === 8))
        throw JsonDecodingException_0(this.ny_1, 'found ] instead of } at path: ' + this.oy_1.toString(), this.l17());
      removeLast(tokenStack);
    } else if (tmp0_subject === 7) {
      if (!(last(tokenStack) === 6))
        throw JsonDecodingException_0(this.ny_1, 'found } instead of ] at path: ' + this.oy_1.toString(), this.l17());
      removeLast(tokenStack);
    } else if (tmp0_subject === 10) {
      this.x11('Unexpected end of input due to malformed JSON during ignoring unknown keys');
    }
    this.e13();
    if (tokenStack.k() === 0)
      return Unit_instance;
  }
};
protoOf(AbstractJsonLexer).toString = function () {
  return "JsonReader(source='" + toString_0(this.l17()) + "', currentPosition=" + this.ny_1 + ')';
};
protoOf(AbstractJsonLexer).p14 = function (key) {
  var processed = this.u17(0, this.ny_1);
  var lastIndexOf_0 = lastIndexOf(processed, key);
  this.w11("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
};
protoOf(AbstractJsonLexer).w11 = function (message, position, hint) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(hint) === 0) {
    tmp = '';
  } else {
    tmp = '\n' + hint;
  }
  var hintMessage = tmp;
  throw JsonDecodingException_0(position, message + ' at path: ' + this.oy_1.k12() + hintMessage, this.l17());
};
protoOf(AbstractJsonLexer).x11 = function (message, position, hint, $super) {
  position = position === VOID ? this.ny_1 : position;
  hint = hint === VOID ? '' : hint;
  return $super === VOID ? this.w11(message, position, hint) : $super.w11.call(this, message, position, hint);
};
protoOf(AbstractJsonLexer).vz = function () {
  var current = this.o17();
  current = this.m17(current);
  if (current >= charSequenceLength(this.l17()) || current === -1) {
    this.x11('EOF');
  }
  var tmp;
  if (charSequenceGet(this.l17(), current) === _Char___init__impl__6a9atx(34)) {
    current = current + 1 | 0;
    if (current === charSequenceLength(this.l17())) {
      this.x11('EOF');
    }
    tmp = true;
  } else {
    tmp = false;
  }
  var hasQuotation = tmp;
  var accumulator = new Long(0, 0);
  var exponentAccumulator = new Long(0, 0);
  var isNegative = false;
  var isExponentPositive = false;
  var hasExponent = false;
  var start = current;
  $l$loop_4: while (!(current === charSequenceLength(this.l17()))) {
    var ch = charSequenceGet(this.l17(), current);
    if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
      if (current === start) {
        this.x11('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
      }
      isExponentPositive = true;
      hasExponent = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
      if (current === start) {
        this.x11("Unexpected symbol '-' in numeric literal");
      }
      isExponentPositive = false;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
      if (current === start) {
        this.x11("Unexpected symbol '+' in numeric literal");
      }
      isExponentPositive = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(45)) {
      if (!(current === start)) {
        this.x11("Unexpected symbol '-' in numeric literal");
      }
      isNegative = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    var token = charToTokenClass(ch);
    if (!(token === 0))
      break $l$loop_4;
    current = current + 1 | 0;
    var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
    if (!(0 <= digit ? digit <= 9 : false)) {
      this.x11("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
    }
    if (hasExponent) {
      // Inline function 'kotlin.Long.times' call
      var this_0 = exponentAccumulator;
      // Inline function 'kotlin.Long.plus' call
      var this_1 = multiply(this_0, fromInt(10));
      exponentAccumulator = add(this_1, fromInt(digit));
      continue $l$loop_4;
    }
    // Inline function 'kotlin.Long.times' call
    var this_2 = accumulator;
    // Inline function 'kotlin.Long.minus' call
    var this_3 = multiply(this_2, fromInt(10));
    accumulator = subtract(this_3, fromInt(digit));
    if (compare(accumulator, new Long(0, 0)) > 0) {
      this.x11('Numeric value overflow');
    }
  }
  var hasChars = !(current === start);
  if (start === current || (isNegative && start === (current - 1 | 0))) {
    this.x11('Expected numeric literal');
  }
  if (hasQuotation) {
    if (!hasChars) {
      this.x11('EOF');
    }
    if (!(charSequenceGet(this.l17(), current) === _Char___init__impl__6a9atx(34))) {
      this.x11('Expected closing quotation mark');
    }
    current = current + 1 | 0;
  }
  this.ny_1 = current;
  if (hasExponent) {
    var doubleAccumulator = toNumber(accumulator) * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
    if (doubleAccumulator > toNumber(new Long(-1, 2147483647)) || doubleAccumulator < toNumber(new Long(0, -2147483648))) {
      this.x11('Numeric value overflow');
    }
    // Inline function 'kotlin.math.floor' call
    if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
      this.x11("Can't convert " + doubleAccumulator + ' to Long');
    }
    accumulator = numberToLong(doubleAccumulator);
  }
  var tmp_0;
  if (isNegative) {
    tmp_0 = accumulator;
  } else if (!equalsLong(accumulator, new Long(0, -2147483648))) {
    tmp_0 = negate(accumulator);
  } else {
    this.x11('Numeric value overflow');
  }
  return tmp_0;
};
protoOf(AbstractJsonLexer).z14 = function () {
  var current = this.o17();
  if (current === charSequenceLength(this.l17())) {
    this.x11('EOF');
  }
  var tmp;
  if (charSequenceGet(this.l17(), current) === _Char___init__impl__6a9atx(34)) {
    current = current + 1 | 0;
    tmp = true;
  } else {
    tmp = false;
  }
  var hasQuotation = tmp;
  var result = consumeBoolean2(this, current);
  if (hasQuotation) {
    if (this.ny_1 === charSequenceLength(this.l17())) {
      this.x11('EOF');
    }
    if (!(charSequenceGet(this.l17(), this.ny_1) === _Char___init__impl__6a9atx(34))) {
      this.x11('Expected closing quotation mark');
    }
    this.ny_1 = this.ny_1 + 1 | 0;
  }
  return result;
};
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().w17_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().v17_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.v17_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.w17_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
function CharMappings() {
  CharMappings_instance = this;
  this.v17_1 = charArray(117);
  this.w17_1 = new Int8Array(126);
  initEscape(this);
  initCharToToken(this);
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance == null)
    new CharMappings();
  return CharMappings_instance;
}
function StringJsonLexerWithComments(source) {
  StringJsonLexer.call(this, source);
}
protoOf(StringJsonLexerWithComments).e13 = function () {
  var source = this.l17();
  var cpos = this.o17();
  if (cpos >= source.length || cpos === -1)
    return 10;
  this.ny_1 = cpos + 1 | 0;
  return charToTokenClass(charCodeAt(source, cpos));
};
protoOf(StringJsonLexerWithComments).a13 = function () {
  var current = this.o17();
  if (current >= this.l17().length || current === -1)
    return false;
  return this.p17(charCodeAt(this.l17(), current));
};
protoOf(StringJsonLexerWithComments).l14 = function (expected) {
  var source = this.l17();
  var current = this.o17();
  if (current >= source.length || current === -1) {
    this.ny_1 = -1;
    this.r17(expected);
  }
  var c = charCodeAt(source, current);
  this.ny_1 = current + 1 | 0;
  if (c === expected)
    return Unit_instance;
  else {
    this.r17(expected);
  }
};
protoOf(StringJsonLexerWithComments).z12 = function () {
  var source = this.l17();
  var cpos = this.o17();
  if (cpos >= source.length || cpos === -1)
    return 10;
  this.ny_1 = cpos;
  return charToTokenClass(charCodeAt(source, cpos));
};
protoOf(StringJsonLexerWithComments).o17 = function () {
  var current = this.ny_1;
  if (current === -1)
    return current;
  var source = this.l17();
  $l$loop_1: while (current < source.length) {
    var c = charCodeAt(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
      continue $l$loop_1;
    }
    if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
      var tmp0_subject = charCodeAt(source, current + 1 | 0);
      if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
        current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
        if (current === -1) {
          current = source.length;
        } else {
          current = current + 1 | 0;
        }
        continue $l$loop_1;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
        current = indexOf(source, '*/', current + 2 | 0);
        if (current === -1) {
          this.ny_1 = source.length;
          this.x11('Expected end of the block comment: "*/", but had EOF instead');
        } else {
          current = current + 2 | 0;
        }
        continue $l$loop_1;
      }
    }
    break $l$loop_1;
  }
  this.ny_1 = current;
  return current;
};
function StringJsonLexer(source) {
  AbstractJsonLexer.call(this);
  this.g18_1 = source;
}
protoOf(StringJsonLexer).l17 = function () {
  return this.g18_1;
};
protoOf(StringJsonLexer).m17 = function (position) {
  return position < this.l17().length ? position : -1;
};
protoOf(StringJsonLexer).e13 = function () {
  var source = this.l17();
  var cpos = this.ny_1;
  $l$loop: while (!(cpos === -1) && cpos < source.length) {
    var _unary__edvuaz = cpos;
    cpos = _unary__edvuaz + 1 | 0;
    var c = charCodeAt(source, _unary__edvuaz);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
      continue $l$loop;
    this.ny_1 = cpos;
    return charToTokenClass(c);
  }
  this.ny_1 = source.length;
  return 10;
};
protoOf(StringJsonLexer).a13 = function () {
  var current = this.ny_1;
  if (current === -1)
    return false;
  var source = this.l17();
  $l$loop: while (current < source.length) {
    var c = charCodeAt(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
      continue $l$loop;
    }
    this.ny_1 = current;
    return this.p17(c);
  }
  this.ny_1 = current;
  return false;
};
protoOf(StringJsonLexer).o17 = function () {
  var current = this.ny_1;
  if (current === -1)
    return current;
  var source = this.l17();
  $l$loop: while (current < source.length) {
    var c = charCodeAt(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
    } else {
      break $l$loop;
    }
  }
  this.ny_1 = current;
  return current;
};
protoOf(StringJsonLexer).l14 = function (expected) {
  if (this.ny_1 === -1) {
    this.r17(expected);
  }
  var source = this.l17();
  var cpos = this.ny_1;
  $l$loop: while (cpos < source.length) {
    var _unary__edvuaz = cpos;
    cpos = _unary__edvuaz + 1 | 0;
    var c = charCodeAt(source, _unary__edvuaz);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
      continue $l$loop;
    this.ny_1 = cpos;
    if (c === expected)
      return Unit_instance;
    this.r17(expected);
  }
  this.ny_1 = -1;
  this.r17(expected);
};
protoOf(StringJsonLexer).r14 = function () {
  this.l14(_Char___init__impl__6a9atx(34));
  var current = this.ny_1;
  var closingQuote = indexOf_0(this.l17(), _Char___init__impl__6a9atx(34), current);
  if (closingQuote === -1) {
    this.c13();
    this.s17(1, false);
  }
  var inductionVariable = current;
  if (inductionVariable < closingQuote)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (charCodeAt(this.l17(), i) === _Char___init__impl__6a9atx(92)) {
        return this.consumeString2(this.l17(), this.ny_1, i);
      }
    }
     while (inductionVariable < closingQuote);
  this.ny_1 = closingQuote + 1 | 0;
  return substring(this.l17(), current, closingQuote);
};
protoOf(StringJsonLexer).t14 = function (keyToMatch, isLenient) {
  var positionSnapshot = this.ny_1;
  try {
    if (!(this.e13() === 6))
      return null;
    var firstKey = this.o14(isLenient);
    if (!(firstKey === keyToMatch))
      return null;
    this.t17();
    if (!(this.e13() === 5))
      return null;
    return this.o14(isLenient);
  }finally {
    this.ny_1 = positionSnapshot;
    this.t17();
  }
};
function StringJsonLexer_0(json, source) {
  return !json.yx_1.hz_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
}
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.ay_1;
}
function JsonToStringWriter() {
  this.dy_1 = StringBuilder_init_$Create$_0(128);
}
protoOf(JsonToStringWriter).b11 = function (value) {
  this.dy_1.k9(value);
};
protoOf(JsonToStringWriter).v10 = function (char) {
  this.dy_1.m6(char);
};
protoOf(JsonToStringWriter).x10 = function (text) {
  this.dy_1.l6(text);
};
protoOf(JsonToStringWriter).h11 = function (text) {
  printQuoted(this.dy_1, text);
};
protoOf(JsonToStringWriter).ey = function () {
  this.dy_1.n9();
};
protoOf(JsonToStringWriter).toString = function () {
  return this.dy_1.toString();
};
function createMapForCache(initialCapacity) {
  return HashMap_init_$Create$(initialCapacity);
}
//region block: post-declaration
protoOf(defer$1).jg = get_isNullable;
protoOf(defer$1).pg = get_isInline;
protoOf(defer$1).rg = get_annotations;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Tombstone_instance = new Tombstone();
//endregion
//region block: exports
export {
  Default_getInstance as Default_getInstance363hicrc7jsft,
};
//endregion

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-json.mjs.map
